(function(){try{if(typeof document<`u`){var e=document.createElement(`style`);e.appendChild(document.createTextNode(`._tooltip_5svgn_1{width:260px}._popover_5svgn_5{background:var(--dixa-color-neutral-000);border-radius:var(--dixa-size-border-radius-100);border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-200);box-shadow:var(--dixa-effect-box-shadow-300);box-sizing:border-box;z-index:100}._bar_1n5dj_1{overflow:hidden}._section_1n5dj_5{position:relative}._sectionHidden_1n5dj_8{display:none!important}._sectionInheritRadius_1n5dj_11{border-radius:inherit}._valueOutside_1n5dj_15{left:calc(100% + var(--dixa-size-spacer-100));z-index:1;position:absolute}:root{--dixa-analytics-color-default-1:var(--dixa-color-purple-700);--dixa-analytics-color-default-2:var(--dixa-color-blue-300);--dixa-analytics-color-default-3:var(--dixa-color-red-500);--dixa-analytics-color-default-4:var(--dixa-color-orange-300);--dixa-analytics-color-default-5:var(--dixa-color-purple-500);--dixa-analytics-color-default-6:var(--dixa-color-green-400);--dixa-analytics-color-default-7:var(--dixa-color-neutral-600);--dixa-analytics-color-default-8:var(--dixa-color-neutral-400);--dixa-analytics-color-rating-1:var(--dixa-color-red-600);--dixa-analytics-color-rating-2:var(--dixa-color-red-400);--dixa-analytics-color-rating-3:var(--dixa-color-orange-300);--dixa-analytics-color-rating-4:var(--dixa-color-green-500);--dixa-analytics-color-rating-5:var(--dixa-color-green-600)}[data-color-mode=dark]{--dixa-analytics-color-default-1:var(--dixa-color-blue-300);--dixa-analytics-color-default-2:var(--dixa-color-blue-700);--dixa-analytics-color-default-3:var(--dixa-color-red-400);--dixa-analytics-color-default-4:var(--dixa-color-orange-600);--dixa-analytics-color-default-5:var(--dixa-color-purple-500);--dixa-analytics-color-default-6:var(--dixa-color-green-500);--dixa-analytics-color-default-7:var(--dixa-color-neutral-400);--dixa-analytics-color-default-8:var(--dixa-color-neutral-800);--dixa-analytics-color-rating-1:var(--dixa-color-red-400);--dixa-analytics-color-rating-2:var(--dixa-color-red-600);--dixa-analytics-color-rating-3:var(--dixa-color-orange-600);--dixa-analytics-color-rating-4:var(--dixa-color-green-400);--dixa-analytics-color-rating-5:var(--dixa-color-green-300)}._container_1t2a7_1{overflow:hidden}._root_6kwn9_1{column-gap:var(--dixa-size-spacer-200);row-gap:var(--dixa-size-spacer-300);white-space:nowrap;display:grid}._root_6kwn9_1:not(._rootBounded_6kwn9_7):not(._rootFluid_6kwn9_7){grid-template-columns:repeat(auto-fit, minmax(min(100% / 2 - var(--dixa-size-spacer-200) * (2 - 1) / 2, max(96px, 100% / 6 - var(--dixa-size-spacer-200) * (6 - 1) / 6)), 1fr))}._rootFluid_6kwn9_7,._rootBounded_6kwn9_7{grid-template-columns:repeat(auto-fit,minmax(96px,1fr))}._rootBounded_6kwn9_7{max-width:calc(6 * 96px + var(--dixa-size-spacer-200) * (6 - 1))}._wrapper_1w7q6_1{align-self:flex-start;display:inline-flex}._text_1w7q6_6{font-size:var(--dixa-typography-size-600)}._colorIndicator_luubh_1{border-radius:50%;flex-shrink:0;width:6px;height:6px}._root_scczo_54{gap:var(--dixa-size-spacer-300);padding:var(--dixa-size-spacer-250);border-radius:var(--dixa-size-border-radius-100);box-shadow:var(--dixa-effect-box-shadow-300);background-color:var(--lightningcss-light,var(--dixa-color-neutral-900))var(--lightningcss-dark,var(--dixa-color-neutral-200));flex-direction:column;display:flex}@supports not (color:light-dark(white, black)){._root_scczo_54{background-color:var(--dixa-color-neutral-900)}}._root_scczo_54{color:var(--lightningcss-light,var(--dixa-color-neutral-000))var(--lightningcss-dark,var(--dixa-typography-color-primary))}@supports not (color:light-dark(white, black)){._root_scczo_54{color:var(--dixa-color-neutral-000)}}._legendItem_15b15_54{white-space:nowrap;cursor:pointer;opacity:1;flex-shrink:0;overflow:hidden}._legendItemInactive_15b15_61{opacity:.4}._legendIcon_15b15_65{border-radius:var(--dixa-size-border-radius-50);border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-200);box-sizing:border-box;flex-shrink:0;width:12px}._legendIconBar_15b15_72{height:12px}._legendIconLine_15b15_75{height:4px}._trigger_1mrk9_1{width:100%;height:100%}._cell_hfkay_1{cursor:default;opacity:1;flex-direction:column;justify-content:center;align-items:center;height:100%;transition:opacity .2s ease-in-out;display:flex}._cell_hfkay_1:hover ._cellText_hfkay_11{color:var(--dixa-typography-color-primary)}._cellDimmed_hfkay_14{opacity:var(--dixa-effect-opacity-200)}._cellContent_hfkay_18{justify-content:center;align-items:center;width:100%;height:100%;display:flex}._cellText_hfkay_11{transition:color .2s ease-in-out}._grid_1qk2p_1{grid-auto-rows:minmax(var(--dixa-size-spacer-500), 1fr);flex-grow:1;display:grid}._row_1qk2p_7{text-align:center;grid-auto-columns:1fr;grid-auto-flow:column;align-items:center;display:grid}._legend_1k9xu_54{position:relative}._trigger_1k9xu_58{position:absolute;top:-50%;right:0}._popover_1k9xu_64{width:256px;max-height:298px;padding:var(--dixa-size-spacer-300);z-index:100;box-sizing:border-box;background:var(--dixa-color-neutral-000);border-radius:var(--dixa-size-border-radius-100);border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-200);box-shadow:var(--dixa-effect-box-shadow-300);margin:0 var(--dixa-size-spacer-200);background:linear-gradient(var(--dixa-color-neutral-000) 33%, #fff0), linear-gradient(#fff0, var(--dixa-color-neutral-000) 66%) 0 100%, radial-gradient(farthest-side at 50% 0, var(--dixa-color-neutral-200), #0000), radial-gradient(farthest-side at 50% 100%, var(--dixa-color-neutral-200), #0000) 0 100%;background-color:var(--dixa-color-neutral-000);background-repeat:no-repeat;background-attachment:local,local,scroll,scroll;background-size:100% var(--dixa-size-spacer-400), 100% var(--dixa-size-spacer-400), 100% var(--dixa-size-spacer-200), 100% var(--dixa-size-spacer-200);overflow-y:auto}._breakdown_1k9xu_83{gap:var(--dixa-size-spacer-250);flex-direction:column;margin:0;padding:0;list-style:none;display:flex}._breakdown_1k9xu_83 li{gap:var(--dixa-size-spacer-200);grid-template-columns:1fr auto;display:grid}._breakdown_1k9xu_83 li>:first-child{white-space:nowrap;text-overflow:ellipsis;overflow:hidden}._tooltip_h4i5v_1{max-width:300px}._trigger_h4i5v_5{opacity:0;width:100%;height:100%;position:absolute;top:0;left:0}._tableWrapper_1xmkm_1{overflow:auto}._tableWrapperEmpty_1xmkm_4{flex-grow:1}._thCell_1xmkm_8{white-space:nowrap}._tdCell_1xmkm_12{white-space:nowrap;text-overflow:ellipsis;max-width:240px;position:relative;overflow:hidden}._tooltip_1xmkm_20{max-width:300px}/*$vite$:1*/`)),document.head.appendChild(e)}}catch(e){console.error(`vite-plugin-css-injected-by-js`,e)}})();
import { Badge as e, Box as t, Button as n, ButtonGroup as r, ButtonList as i, Divider as a, EmptyState as o, FlexBox as s, HelpIcon as c, IconButton as l, Pagination as u, Table as d, Text as f, Tooltip as p } from "@dixa/lib-shared-habla";
import * as m from "react";
import { Children as h, Fragment as g, cloneElement as _, createContext as v, createElement as y, forwardRef as b, isValidElement as x, memo as S, useCallback as C, useContext as w, useEffect as T, useLayoutEffect as E, useMemo as D, useReducer as O, useRef as k, useState as A } from "react";
import * as j from "react-dom";
import M, { flushSync as ee } from "react-dom";
import { Fragment as N, jsx as P, jsxs as F } from "react/jsx-runtime";
import I from "classnames";
import { useInterval as te, useList as ne, useMap as re, usePrevious as ie, useUpdateEffect as ae } from "react-use";
import { Area as oe, AreaChart as se, Bar as ce, BarChart as le, CartesianGrid as ue, Cell as de, Label as fe, LabelList as pe, Legend as me, Line as he, LineChart as ge, Pie as _e, PieChart as ve, ReferenceLine as ye, ResponsiveContainer as be, Sector as xe, Tooltip as Se, XAxis as Ce, YAxis as we } from "recharts";
import Te from "moment-timezone";
import { colors as Ee, typography as De } from "@dixa/lib-shared-tokens";
import Oe from "lodash/truncate";
import ke from "lodash/capitalize";
import Ae from "lodash/debounce";
import je from "lodash/last";
import Me from "lodash/pick";
import Ne from "lodash/sum";
import Pe from "lodash/isEqual";
import Fe from "lodash/isNumber";
import { TagChips as Ie } from "lib-shared-tagging";
import Le from "lodash/isNil";
import Re from "lodash/orderBy";
//#region \0rolldown/runtime.js
var ze = Object.create, Be = Object.defineProperty, Ve = Object.getOwnPropertyDescriptor, He = Object.getOwnPropertyNames, Ue = Object.getPrototypeOf, We = Object.prototype.hasOwnProperty, Ge = (e, t, n) => () => {
	if (n) throw n[0];
	try {
		return e && (t = e(e = 0)), t;
	} catch (e) {
		throw n = [e], e;
	}
}, Ke = (e, t) => () => (t || (e((t = { exports: {} }).exports, t), e = null), t.exports), qe = (e, t) => {
	let n = {};
	for (var r in e) Be(n, r, {
		get: e[r],
		enumerable: !0
	});
	return t || Be(n, Symbol.toStringTag, { value: "Module" }), n;
}, Je = (e, t, n, r) => {
	if (t && typeof t == "object" || typeof t == "function") for (var i = He(t), a = 0, o = i.length, s; a < o; a++) s = i[a], !We.call(e, s) && s !== n && Be(e, s, {
		get: ((e) => t[e]).bind(null, s),
		enumerable: !(r = Ve(t, s)) || r.enumerable
	});
	return e;
}, Ye = (e, t, n) => (n = e == null ? {} : ze(Ue(e)), Je(t || !e || !e.__esModule ? Be(n, "default", {
	value: e,
	enumerable: !0
}) : n, e)), Xe = (e) => We.call(e, "module.exports") ? e["module.exports"] : Je(Be({}, "__esModule", { value: !0 }), e);
//#endregion
//#region ../../../node_modules/@radix-ui/react-popover/node_modules/@babel/runtime/helpers/esm/extends.js
function L() {
	return L = Object.assign ? Object.assign.bind() : function(e) {
		for (var t = 1; t < arguments.length; t++) {
			var n = arguments[t];
			for (var r in n) Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
		}
		return e;
	}, L.apply(this, arguments);
}
//#endregion
//#region ../../../node_modules/@radix-ui/react-popover/node_modules/@radix-ui/primitive/dist/index.mjs
function Ze(e, t, { checkForDefaultPrevented: n = !0 } = {}) {
	return function(r) {
		if (e?.(r), n === !1 || !r.defaultPrevented) return t?.(r);
	};
}
//#endregion
//#region ../../../node_modules/@radix-ui/react-popover/node_modules/@radix-ui/react-compose-refs/dist/index.mjs
function Qe(e, t) {
	typeof e == "function" ? e(t) : e != null && (e.current = t);
}
function $e(...e) {
	return (t) => e.forEach((e) => Qe(e, t));
}
function et(...e) {
	return C($e(...e), e);
}
//#endregion
//#region ../../../node_modules/@radix-ui/react-popover/node_modules/@radix-ui/react-context/dist/index.mjs
function tt(e, t = []) {
	let n = [];
	function r(t, r) {
		let i = /*#__PURE__*/ v(r), a = n.length;
		n = [...n, r];
		function o(t) {
			let { scope: n, children: r, ...o } = t, s = n?.[e][a] || i, c = D(() => o, Object.values(o));
			return /*#__PURE__*/ y(s.Provider, { value: c }, r);
		}
		function s(n, o) {
			let s = w(o?.[e][a] || i);
			if (s) return s;
			if (r !== void 0) return r;
			throw Error(`\`${n}\` must be used within \`${t}\``);
		}
		return o.displayName = t + "Provider", [o, s];
	}
	let i = () => {
		let t = n.map((e) => /*#__PURE__*/ v(e));
		return function(n) {
			let r = n?.[e] || t;
			return D(() => ({ [`__scope${e}`]: {
				...n,
				[e]: r
			} }), [n, r]);
		};
	};
	return i.scopeName = e, [r, nt(i, ...t)];
}
function nt(...e) {
	let t = e[0];
	if (e.length === 1) return t;
	let n = () => {
		let n = e.map((e) => ({
			useScope: e(),
			scopeName: e.scopeName
		}));
		return function(e) {
			let r = n.reduce((t, { useScope: n, scopeName: r }) => {
				let i = n(e)[`__scope${r}`];
				return {
					...t,
					...i
				};
			}, {});
			return D(() => ({ [`__scope${t.scopeName}`]: r }), [r]);
		};
	};
	return n.scopeName = t.scopeName, n;
}
//#endregion
//#region ../../../node_modules/@radix-ui/react-dismissable-layer/node_modules/@babel/runtime/helpers/esm/extends.js
function rt() {
	return rt = Object.assign ? Object.assign.bind() : function(e) {
		for (var t = 1; t < arguments.length; t++) {
			var n = arguments[t];
			for (var r in n) Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
		}
		return e;
	}, rt.apply(this, arguments);
}
//#endregion
//#region ../../../node_modules/@radix-ui/react-dismissable-layer/node_modules/@radix-ui/primitive/dist/index.mjs
function it(e, t, { checkForDefaultPrevented: n = !0 } = {}) {
	return function(r) {
		if (e?.(r), n === !1 || !r.defaultPrevented) return t?.(r);
	};
}
//#endregion
//#region ../../../node_modules/@radix-ui/react-slot/node_modules/@babel/runtime/helpers/esm/extends.js
function at() {
	return at = Object.assign ? Object.assign.bind() : function(e) {
		for (var t = 1; t < arguments.length; t++) {
			var n = arguments[t];
			for (var r in n) Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
		}
		return e;
	}, at.apply(this, arguments);
}
//#endregion
//#region ../../../node_modules/@radix-ui/react-slot/node_modules/@radix-ui/react-compose-refs/dist/index.mjs
function ot(e, t) {
	typeof e == "function" ? e(t) : e != null && (e.current = t);
}
function st(...e) {
	return (t) => e.forEach((e) => ot(e, t));
}
//#endregion
//#region ../../../node_modules/@radix-ui/react-slot/dist/index.mjs
var ct = /*#__PURE__*/ b((e, t) => {
	let { children: n, ...r } = e, i = h.toArray(n), a = i.find(dt);
	if (a) {
		let e = a.props.children, n = i.map((t) => t === a ? h.count(e) > 1 ? h.only(null) : /*#__PURE__*/ x(e) ? e.props.children : null : t);
		return /*#__PURE__*/ y(lt, at({}, r, { ref: t }), /*#__PURE__*/ x(e) ? /*#__PURE__*/ _(e, void 0, n) : null);
	}
	return /*#__PURE__*/ y(lt, at({}, r, { ref: t }), n);
});
ct.displayName = "Slot";
var lt = /*#__PURE__*/ b((e, t) => {
	let { children: n, ...r } = e;
	return /*#__PURE__*/ x(n) ? /*#__PURE__*/ _(n, {
		...ft(r, n.props),
		ref: t ? st(t, n.ref) : n.ref
	}) : h.count(n) > 1 ? h.only(null) : null;
});
lt.displayName = "SlotClone";
var ut = ({ children: e }) => /*#__PURE__*/ y(g, null, e);
function dt(e) {
	return /*#__PURE__*/ x(e) && e.type === ut;
}
function ft(e, t) {
	let n = { ...t };
	for (let r in t) {
		let i = e[r], a = t[r];
		/^on[A-Z]/.test(r) ? i && a ? n[r] = (...e) => {
			a(...e), i(...e);
		} : i && (n[r] = i) : r === "style" ? n[r] = {
			...i,
			...a
		} : r === "className" && (n[r] = [i, a].filter(Boolean).join(" "));
	}
	return {
		...e,
		...n
	};
}
//#endregion
//#region ../../../node_modules/@radix-ui/react-dismissable-layer/node_modules/@radix-ui/react-primitive/dist/index.mjs
var pt = [
	"a",
	"button",
	"div",
	"form",
	"h2",
	"h3",
	"img",
	"input",
	"label",
	"li",
	"nav",
	"ol",
	"p",
	"span",
	"svg",
	"ul"
].reduce((e, t) => {
	let n = /*#__PURE__*/ b((e, n) => {
		let { asChild: r, ...i } = e, a = r ? ct : t;
		return T(() => {
			window[Symbol.for("radix-ui")] = !0;
		}, []), /*#__PURE__*/ y(a, rt({}, i, { ref: n }));
	});
	return n.displayName = `Primitive.${t}`, {
		...e,
		[t]: n
	};
}, {});
function mt(e, t) {
	e && ee(() => e.dispatchEvent(t));
}
//#endregion
//#region ../../../node_modules/@radix-ui/react-dismissable-layer/node_modules/@radix-ui/react-compose-refs/dist/index.mjs
function ht(e, t) {
	typeof e == "function" ? e(t) : e != null && (e.current = t);
}
function gt(...e) {
	return (t) => e.forEach((e) => ht(e, t));
}
function _t(...e) {
	return C(gt(...e), e);
}
//#endregion
//#region ../../../node_modules/@radix-ui/react-dismissable-layer/node_modules/@radix-ui/react-use-callback-ref/dist/index.mjs
function vt(e) {
	let t = k(e);
	return T(() => {
		t.current = e;
	}), D(() => (...e) => t.current?.call(t, ...e), []);
}
//#endregion
//#region ../../../node_modules/@radix-ui/react-dismissable-layer/node_modules/@radix-ui/react-use-escape-keydown/dist/index.mjs
function yt(e, t = globalThis == null ? void 0 : globalThis.document) {
	let n = vt(e);
	T(() => {
		let e = (e) => {
			e.key === "Escape" && n(e);
		};
		return t.addEventListener("keydown", e), () => t.removeEventListener("keydown", e);
	}, [n, t]);
}
//#endregion
//#region ../../../node_modules/@radix-ui/react-dismissable-layer/dist/index.mjs
var bt = "dismissableLayer.update", xt = "dismissableLayer.pointerDownOutside", St = "dismissableLayer.focusOutside", Ct, wt = /*#__PURE__*/ v({
	layers: /* @__PURE__ */ new Set(),
	layersWithOutsidePointerEventsDisabled: /* @__PURE__ */ new Set(),
	branches: /* @__PURE__ */ new Set()
}), Tt = /*#__PURE__*/ b((e, t) => {
	let { disableOutsidePointerEvents: n = !1, onEscapeKeyDown: r, onPointerDownOutside: i, onFocusOutside: a, onInteractOutside: o, onDismiss: s, ...c } = e, l = w(wt), [u, d] = A(null), f = u?.ownerDocument ?? (globalThis == null ? void 0 : globalThis.document), [, p] = A({}), m = _t(t, (e) => d(e)), h = Array.from(l.layers), [g] = [...l.layersWithOutsidePointerEventsDisabled].slice(-1), _ = h.indexOf(g), v = u ? h.indexOf(u) : -1, b = l.layersWithOutsidePointerEventsDisabled.size > 0, x = v >= _, S = Et((e) => {
		let t = e.target, n = [...l.branches].some((e) => e.contains(t));
		!x || n || (i?.(e), o?.(e), e.defaultPrevented || s?.());
	}, f), C = Dt((e) => {
		let t = e.target;
		[...l.branches].some((e) => e.contains(t)) || (a?.(e), o?.(e), e.defaultPrevented || s?.());
	}, f);
	return yt((e) => {
		v === l.layers.size - 1 && (r?.(e), !e.defaultPrevented && s && (e.preventDefault(), s()));
	}, f), T(() => {
		if (u) return n && (l.layersWithOutsidePointerEventsDisabled.size === 0 && (Ct = f.body.style.pointerEvents, f.body.style.pointerEvents = "none"), l.layersWithOutsidePointerEventsDisabled.add(u)), l.layers.add(u), Ot(), () => {
			n && l.layersWithOutsidePointerEventsDisabled.size === 1 && (f.body.style.pointerEvents = Ct);
		};
	}, [
		u,
		f,
		n,
		l
	]), T(() => () => {
		u && (l.layers.delete(u), l.layersWithOutsidePointerEventsDisabled.delete(u), Ot());
	}, [u, l]), T(() => {
		let e = () => p({});
		return document.addEventListener(bt, e), () => document.removeEventListener(bt, e);
	}, []), /*#__PURE__*/ y(pt.div, rt({}, c, {
		ref: m,
		style: {
			pointerEvents: b ? x ? "auto" : "none" : void 0,
			...e.style
		},
		onFocusCapture: it(e.onFocusCapture, C.onFocusCapture),
		onBlurCapture: it(e.onBlurCapture, C.onBlurCapture),
		onPointerDownCapture: it(e.onPointerDownCapture, S.onPointerDownCapture)
	}));
});
function Et(e, t = globalThis == null ? void 0 : globalThis.document) {
	let n = vt(e), r = k(!1), i = k(() => {});
	return T(() => {
		let e = (e) => {
			if (e.target && !r.current) {
				let r = { originalEvent: e };
				function a() {
					kt(xt, n, r, { discrete: !0 });
				}
				e.pointerType === "touch" ? (t.removeEventListener("click", i.current), i.current = a, t.addEventListener("click", i.current, { once: !0 })) : a();
			} else t.removeEventListener("click", i.current);
			r.current = !1;
		}, a = window.setTimeout(() => {
			t.addEventListener("pointerdown", e);
		}, 0);
		return () => {
			window.clearTimeout(a), t.removeEventListener("pointerdown", e), t.removeEventListener("click", i.current);
		};
	}, [t, n]), { onPointerDownCapture: () => r.current = !0 };
}
function Dt(e, t = globalThis == null ? void 0 : globalThis.document) {
	let n = vt(e), r = k(!1);
	return T(() => {
		let e = (e) => {
			e.target && !r.current && kt(St, n, { originalEvent: e }, { discrete: !1 });
		};
		return t.addEventListener("focusin", e), () => t.removeEventListener("focusin", e);
	}, [t, n]), {
		onFocusCapture: () => r.current = !0,
		onBlurCapture: () => r.current = !1
	};
}
function Ot() {
	let e = new CustomEvent(bt);
	document.dispatchEvent(e);
}
function kt(e, t, n, { discrete: r }) {
	let i = n.originalEvent.target, a = new CustomEvent(e, {
		bubbles: !1,
		cancelable: !0,
		detail: n
	});
	t && i.addEventListener(e, t, { once: !0 }), r ? mt(i, a) : i.dispatchEvent(a);
}
//#endregion
//#region ../../../node_modules/@radix-ui/react-focus-guards/dist/index.mjs
var At = 0;
function jt() {
	T(() => {
		let e = document.querySelectorAll("[data-radix-focus-guard]");
		return document.body.insertAdjacentElement("afterbegin", e[0] ?? Mt()), document.body.insertAdjacentElement("beforeend", e[1] ?? Mt()), At++, () => {
			At === 1 && document.querySelectorAll("[data-radix-focus-guard]").forEach((e) => e.remove()), At--;
		};
	}, []);
}
function Mt() {
	let e = document.createElement("span");
	return e.setAttribute("data-radix-focus-guard", ""), e.tabIndex = 0, e.style.cssText = "outline: none; opacity: 0; position: fixed; pointer-events: none", e;
}
//#endregion
//#region ../../../node_modules/@radix-ui/react-focus-scope/node_modules/@babel/runtime/helpers/esm/extends.js
function Nt() {
	return Nt = Object.assign ? Object.assign.bind() : function(e) {
		for (var t = 1; t < arguments.length; t++) {
			var n = arguments[t];
			for (var r in n) Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
		}
		return e;
	}, Nt.apply(this, arguments);
}
//#endregion
//#region ../../../node_modules/@radix-ui/react-focus-scope/node_modules/@radix-ui/react-compose-refs/dist/index.mjs
function Pt(e, t) {
	typeof e == "function" ? e(t) : e != null && (e.current = t);
}
function Ft(...e) {
	return (t) => e.forEach((e) => Pt(e, t));
}
function It(...e) {
	return C(Ft(...e), e);
}
//#endregion
//#region ../../../node_modules/@radix-ui/react-focus-scope/node_modules/@radix-ui/react-primitive/dist/index.mjs
var Lt = [
	"a",
	"button",
	"div",
	"form",
	"h2",
	"h3",
	"img",
	"input",
	"label",
	"li",
	"nav",
	"ol",
	"p",
	"span",
	"svg",
	"ul"
].reduce((e, t) => {
	let n = /*#__PURE__*/ b((e, n) => {
		let { asChild: r, ...i } = e, a = r ? ct : t;
		return T(() => {
			window[Symbol.for("radix-ui")] = !0;
		}, []), /*#__PURE__*/ y(a, Nt({}, i, { ref: n }));
	});
	return n.displayName = `Primitive.${t}`, {
		...e,
		[t]: n
	};
}, {});
//#endregion
//#region ../../../node_modules/@radix-ui/react-focus-scope/node_modules/@radix-ui/react-use-callback-ref/dist/index.mjs
function Rt(e) {
	let t = k(e);
	return T(() => {
		t.current = e;
	}), D(() => (...e) => t.current?.call(t, ...e), []);
}
//#endregion
//#region ../../../node_modules/@radix-ui/react-focus-scope/dist/index.mjs
var zt = "focusScope.autoFocusOnMount", Bt = "focusScope.autoFocusOnUnmount", Vt = {
	bubbles: !1,
	cancelable: !0
}, Ht = /*#__PURE__*/ b((e, t) => {
	let { loop: n = !1, trapped: r = !1, onMountAutoFocus: i, onUnmountAutoFocus: a, ...o } = e, [s, c] = A(null), l = Rt(i), u = Rt(a), d = k(null), f = It(t, (e) => c(e)), p = k({
		paused: !1,
		pause() {
			this.paused = !0;
		},
		resume() {
			this.paused = !1;
		}
	}).current;
	T(() => {
		if (r) {
			function e(e) {
				if (p.paused || !s) return;
				let t = e.target;
				s.contains(t) ? d.current = t : R(d.current, { select: !0 });
			}
			function t(e) {
				if (p.paused || !s) return;
				let t = e.relatedTarget;
				t !== null && (s.contains(t) || R(d.current, { select: !0 }));
			}
			function n(e) {
				if (document.activeElement === document.body) for (let t of e) t.removedNodes.length > 0 && R(s);
			}
			document.addEventListener("focusin", e), document.addEventListener("focusout", t);
			let r = new MutationObserver(n);
			return s && r.observe(s, {
				childList: !0,
				subtree: !0
			}), () => {
				document.removeEventListener("focusin", e), document.removeEventListener("focusout", t), r.disconnect();
			};
		}
	}, [
		r,
		s,
		p.paused
	]), T(() => {
		if (s) {
			Yt.add(p);
			let e = document.activeElement;
			if (!s.contains(e)) {
				let t = new CustomEvent(zt, Vt);
				s.addEventListener(zt, l), s.dispatchEvent(t), t.defaultPrevented || (Ut(Qt(Gt(s)), { select: !0 }), document.activeElement === e && R(s));
			}
			return () => {
				s.removeEventListener(zt, l), setTimeout(() => {
					let t = new CustomEvent(Bt, Vt);
					s.addEventListener(Bt, u), s.dispatchEvent(t), t.defaultPrevented || R(e ?? document.body, { select: !0 }), s.removeEventListener(Bt, u), Yt.remove(p);
				}, 0);
			};
		}
	}, [
		s,
		l,
		u,
		p
	]);
	let m = C((e) => {
		if (!n && !r || p.paused) return;
		let t = e.key === "Tab" && !e.altKey && !e.ctrlKey && !e.metaKey, i = document.activeElement;
		if (t && i) {
			let t = e.currentTarget, [r, a] = Wt(t);
			r && a ? !e.shiftKey && i === a ? (e.preventDefault(), n && R(r, { select: !0 })) : e.shiftKey && i === r && (e.preventDefault(), n && R(a, { select: !0 })) : i === t && e.preventDefault();
		}
	}, [
		n,
		r,
		p.paused
	]);
	return /*#__PURE__*/ y(Lt.div, Nt({ tabIndex: -1 }, o, {
		ref: f,
		onKeyDown: m
	}));
});
function Ut(e, { select: t = !1 } = {}) {
	let n = document.activeElement;
	for (let r of e) if (R(r, { select: t }), document.activeElement !== n) return;
}
function Wt(e) {
	let t = Gt(e);
	return [Kt(t, e), Kt(t.reverse(), e)];
}
function Gt(e) {
	let t = [], n = document.createTreeWalker(e, NodeFilter.SHOW_ELEMENT, { acceptNode: (e) => {
		let t = e.tagName === "INPUT" && e.type === "hidden";
		return e.disabled || e.hidden || t ? NodeFilter.FILTER_SKIP : e.tabIndex >= 0 ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
	} });
	for (; n.nextNode();) t.push(n.currentNode);
	return t;
}
function Kt(e, t) {
	for (let n of e) if (!qt(n, { upTo: t })) return n;
}
function qt(e, { upTo: t }) {
	if (getComputedStyle(e).visibility === "hidden") return !0;
	for (; e;) {
		if (t !== void 0 && e === t) return !1;
		if (getComputedStyle(e).display === "none") return !0;
		e = e.parentElement;
	}
	return !1;
}
function Jt(e) {
	return e instanceof HTMLInputElement && "select" in e;
}
function R(e, { select: t = !1 } = {}) {
	if (e && e.focus) {
		let n = document.activeElement;
		e.focus({ preventScroll: !0 }), e !== n && Jt(e) && t && e.select();
	}
}
var Yt = Xt();
function Xt() {
	let e = [];
	return {
		add(t) {
			let n = e[0];
			t !== n && n?.pause(), e = Zt(e, t), e.unshift(t);
		},
		remove(t) {
			var n;
			e = Zt(e, t), (n = e[0]) == null || n.resume();
		}
	};
}
function Zt(e, t) {
	let n = [...e], r = n.indexOf(t);
	return r !== -1 && n.splice(r, 1), n;
}
function Qt(e) {
	return e.filter((e) => e.tagName !== "A");
}
//#endregion
//#region ../../../node_modules/@radix-ui/react-id/node_modules/@radix-ui/react-use-layout-effect/dist/index.mjs
var $t = globalThis != null && globalThis.document ? E : () => {}, en = m.useId || (() => void 0), tn = 0;
function nn(e) {
	let [t, n] = m.useState(en());
	return $t(() => {
		e || n((e) => e ?? String(tn++));
	}, [e]), e || (t ? `radix-${t}` : "");
}
//#endregion
//#region ../../../node_modules/@radix-ui/react-popper/node_modules/@babel/runtime/helpers/esm/extends.js
function rn() {
	return rn = Object.assign ? Object.assign.bind() : function(e) {
		for (var t = 1; t < arguments.length; t++) {
			var n = arguments[t];
			for (var r in n) Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
		}
		return e;
	}, rn.apply(this, arguments);
}
//#endregion
//#region ../../../node_modules/@floating-ui/react-dom/node_modules/@floating-ui/utils/dist/floating-ui.utils.mjs
var an = [
	"top",
	"right",
	"bottom",
	"left"
], z = Math.min, B = Math.max, on = Math.round, sn = Math.floor, V = (e) => ({
	x: e,
	y: e
}), cn = {
	left: "right",
	right: "left",
	bottom: "top",
	top: "bottom"
}, ln = {
	start: "end",
	end: "start"
};
function un(e, t, n) {
	return B(e, z(t, n));
}
function H(e, t) {
	return typeof e == "function" ? e(t) : e;
}
function U(e) {
	return e.split("-")[0];
}
function dn(e) {
	return e.split("-")[1];
}
function fn(e) {
	return e === "x" ? "y" : "x";
}
function pn(e) {
	return e === "y" ? "height" : "width";
}
function mn(e) {
	return ["top", "bottom"].includes(U(e)) ? "y" : "x";
}
function hn(e) {
	return fn(mn(e));
}
function gn(e, t, n) {
	n === void 0 && (n = !1);
	let r = dn(e), i = hn(e), a = pn(i), o = i === "x" ? r === (n ? "end" : "start") ? "right" : "left" : r === "start" ? "bottom" : "top";
	return t.reference[a] > t.floating[a] && (o = xn(o)), [o, xn(o)];
}
function _n(e) {
	let t = xn(e);
	return [
		vn(e),
		t,
		vn(t)
	];
}
function vn(e) {
	return e.replace(/start|end/g, (e) => ln[e]);
}
function yn(e, t, n) {
	let r = ["left", "right"], i = ["right", "left"], a = ["top", "bottom"], o = ["bottom", "top"];
	switch (e) {
		case "top":
		case "bottom": return n ? t ? i : r : t ? r : i;
		case "left":
		case "right": return t ? a : o;
		default: return [];
	}
}
function bn(e, t, n, r) {
	let i = dn(e), a = yn(U(e), n === "start", r);
	return i && (a = a.map((e) => e + "-" + i), t && (a = a.concat(a.map(vn)))), a;
}
function xn(e) {
	return e.replace(/left|right|bottom|top/g, (e) => cn[e]);
}
function Sn(e) {
	return {
		top: 0,
		right: 0,
		bottom: 0,
		left: 0,
		...e
	};
}
function Cn(e) {
	return typeof e == "number" ? {
		top: e,
		right: e,
		bottom: e,
		left: e
	} : Sn(e);
}
function wn(e) {
	return {
		...e,
		top: e.y,
		left: e.x,
		right: e.x + e.width,
		bottom: e.y + e.height
	};
}
//#endregion
//#region ../../../node_modules/@floating-ui/react-dom/node_modules/@floating-ui/core/dist/floating-ui.core.mjs
function Tn(e, t, n) {
	let { reference: r, floating: i } = e, a = mn(t), o = hn(t), s = pn(o), c = U(t), l = a === "y", u = r.x + r.width / 2 - i.width / 2, d = r.y + r.height / 2 - i.height / 2, f = r[s] / 2 - i[s] / 2, p;
	switch (c) {
		case "top":
			p = {
				x: u,
				y: r.y - i.height
			};
			break;
		case "bottom":
			p = {
				x: u,
				y: r.y + r.height
			};
			break;
		case "right":
			p = {
				x: r.x + r.width,
				y: d
			};
			break;
		case "left":
			p = {
				x: r.x - i.width,
				y: d
			};
			break;
		default: p = {
			x: r.x,
			y: r.y
		};
	}
	switch (dn(t)) {
		case "start":
			p[o] -= f * (n && l ? -1 : 1);
			break;
		case "end":
			p[o] += f * (n && l ? -1 : 1);
			break;
	}
	return p;
}
var En = async (e, t, n) => {
	let { placement: r = "bottom", strategy: i = "absolute", middleware: a = [], platform: o } = n, s = a.filter(Boolean), c = await (o.isRTL == null ? void 0 : o.isRTL(t)), l = await o.getElementRects({
		reference: e,
		floating: t,
		strategy: i
	}), { x: u, y: d } = Tn(l, r, c), f = r, p = {}, m = 0;
	for (let n = 0; n < s.length; n++) {
		let { name: a, fn: h } = s[n], { x: g, y: _, data: v, reset: y } = await h({
			x: u,
			y: d,
			initialPlacement: r,
			placement: f,
			strategy: i,
			middlewareData: p,
			rects: l,
			platform: o,
			elements: {
				reference: e,
				floating: t
			}
		});
		if (u = g ?? u, d = _ ?? d, p = {
			...p,
			[a]: {
				...p[a],
				...v
			}
		}, y && m <= 50) {
			m++, typeof y == "object" && (y.placement && (f = y.placement), y.rects && (l = y.rects === !0 ? await o.getElementRects({
				reference: e,
				floating: t,
				strategy: i
			}) : y.rects), {x: u, y: d} = Tn(l, f, c)), n = -1;
			continue;
		}
	}
	return {
		x: u,
		y: d,
		placement: f,
		strategy: i,
		middlewareData: p
	};
};
async function Dn(e, t) {
	t === void 0 && (t = {});
	let { x: n, y: r, platform: i, rects: a, elements: o, strategy: s } = e, { boundary: c = "clippingAncestors", rootBoundary: l = "viewport", elementContext: u = "floating", altBoundary: d = !1, padding: f = 0 } = H(t, e), p = Cn(f), m = o[d ? u === "floating" ? "reference" : "floating" : u], h = wn(await i.getClippingRect({
		element: await (i.isElement == null ? void 0 : i.isElement(m)) ?? !0 ? m : m.contextElement || await (i.getDocumentElement == null ? void 0 : i.getDocumentElement(o.floating)),
		boundary: c,
		rootBoundary: l,
		strategy: s
	})), g = u === "floating" ? {
		...a.floating,
		x: n,
		y: r
	} : a.reference, _ = await (i.getOffsetParent == null ? void 0 : i.getOffsetParent(o.floating)), v = await (i.isElement == null ? void 0 : i.isElement(_)) && await (i.getScale == null ? void 0 : i.getScale(_)) || {
		x: 1,
		y: 1
	}, y = wn(i.convertOffsetParentRelativeRectToViewportRelativeRect ? await i.convertOffsetParentRelativeRectToViewportRelativeRect({
		rect: g,
		offsetParent: _,
		strategy: s
	}) : g);
	return {
		top: (h.top - y.top + p.top) / v.y,
		bottom: (y.bottom - h.bottom + p.bottom) / v.y,
		left: (h.left - y.left + p.left) / v.x,
		right: (y.right - h.right + p.right) / v.x
	};
}
var On = (e) => ({
	name: "arrow",
	options: e,
	async fn(t) {
		let { x: n, y: r, placement: i, rects: a, platform: o, elements: s } = t, { element: c, padding: l = 0 } = H(e, t) || {};
		if (c == null) return {};
		let u = Cn(l), d = {
			x: n,
			y: r
		}, f = hn(i), p = pn(f), m = await o.getDimensions(c), h = f === "y", g = h ? "top" : "left", _ = h ? "bottom" : "right", v = h ? "clientHeight" : "clientWidth", y = a.reference[p] + a.reference[f] - d[f] - a.floating[p], b = d[f] - a.reference[f], x = await (o.getOffsetParent == null ? void 0 : o.getOffsetParent(c)), S = x ? x[v] : 0;
		(!S || !await (o.isElement == null ? void 0 : o.isElement(x))) && (S = s.floating[v] || a.floating[p]);
		let C = y / 2 - b / 2, w = S / 2 - m[p] / 2 - 1, T = z(u[g], w), E = z(u[_], w), D = T, O = S - m[p] - E, k = S / 2 - m[p] / 2 + C, A = un(D, k, O), j = dn(i) != null && k != A && a.reference[p] / 2 - (k < D ? T : E) - m[p] / 2 < 0 ? k < D ? D - k : O - k : 0;
		return {
			[f]: d[f] - j,
			data: {
				[f]: A,
				centerOffset: k - A + j
			}
		};
	}
}), kn = function(e) {
	return e === void 0 && (e = {}), {
		name: "flip",
		options: e,
		async fn(t) {
			let { placement: n, middlewareData: r, rects: i, initialPlacement: a, platform: o, elements: s } = t, { mainAxis: c = !0, crossAxis: l = !0, fallbackPlacements: u, fallbackStrategy: d = "bestFit", fallbackAxisSideDirection: f = "none", flipAlignment: p = !0, ...m } = H(e, t), h = U(n), g = U(a) === a, _ = await (o.isRTL == null ? void 0 : o.isRTL(s.floating)), v = u || (g || !p ? [xn(a)] : _n(a));
			!u && f !== "none" && v.push(...bn(a, p, f, _));
			let y = [a, ...v], b = await Dn(t, m), x = [], S = r.flip?.overflows || [];
			if (c && x.push(b[h]), l) {
				let e = gn(n, i, _);
				x.push(b[e[0]], b[e[1]]);
			}
			if (S = [...S, {
				placement: n,
				overflows: x
			}], !x.every((e) => e <= 0)) {
				let e = (r.flip?.index || 0) + 1, t = y[e];
				if (t) return {
					data: {
						index: e,
						overflows: S
					},
					reset: { placement: t }
				};
				let i = S.filter((e) => e.overflows[0] <= 0).sort((e, t) => e.overflows[1] - t.overflows[1])[0]?.placement;
				if (!i) switch (d) {
					case "bestFit": {
						let e = S.map((e) => [e.placement, e.overflows.filter((e) => e > 0).reduce((e, t) => e + t, 0)]).sort((e, t) => e[1] - t[1])[0]?.[0];
						e && (i = e);
						break;
					}
					case "initialPlacement":
						i = a;
						break;
				}
				if (n !== i) return { reset: { placement: i } };
			}
			return {};
		}
	};
};
function An(e, t) {
	return {
		top: e.top - t.height,
		right: e.right - t.width,
		bottom: e.bottom - t.height,
		left: e.left - t.width
	};
}
function jn(e) {
	return an.some((t) => e[t] >= 0);
}
var Mn = function(e) {
	return e === void 0 && (e = {}), {
		name: "hide",
		options: e,
		async fn(t) {
			let { rects: n } = t, { strategy: r = "referenceHidden", ...i } = H(e, t);
			switch (r) {
				case "referenceHidden": {
					let e = An(await Dn(t, {
						...i,
						elementContext: "reference"
					}), n.reference);
					return { data: {
						referenceHiddenOffsets: e,
						referenceHidden: jn(e)
					} };
				}
				case "escaped": {
					let e = An(await Dn(t, {
						...i,
						altBoundary: !0
					}), n.floating);
					return { data: {
						escapedOffsets: e,
						escaped: jn(e)
					} };
				}
				default: return {};
			}
		}
	};
};
async function Nn(e, t) {
	let { placement: n, platform: r, elements: i } = e, a = await (r.isRTL == null ? void 0 : r.isRTL(i.floating)), o = U(n), s = dn(n), c = mn(n) === "y", l = ["left", "top"].includes(o) ? -1 : 1, u = a && c ? -1 : 1, d = H(t, e), { mainAxis: f, crossAxis: p, alignmentAxis: m } = typeof d == "number" ? {
		mainAxis: d,
		crossAxis: 0,
		alignmentAxis: null
	} : {
		mainAxis: 0,
		crossAxis: 0,
		alignmentAxis: null,
		...d
	};
	return s && typeof m == "number" && (p = s === "end" ? m * -1 : m), c ? {
		x: p * u,
		y: f * l
	} : {
		x: f * l,
		y: p * u
	};
}
var Pn = function(e) {
	return e === void 0 && (e = 0), {
		name: "offset",
		options: e,
		async fn(t) {
			let { x: n, y: r } = t, i = await Nn(t, e);
			return {
				x: n + i.x,
				y: r + i.y,
				data: i
			};
		}
	};
}, Fn = function(e) {
	return e === void 0 && (e = {}), {
		name: "shift",
		options: e,
		async fn(t) {
			let { x: n, y: r, placement: i } = t, { mainAxis: a = !0, crossAxis: o = !1, limiter: s = { fn: (e) => {
				let { x: t, y: n } = e;
				return {
					x: t,
					y: n
				};
			} }, ...c } = H(e, t), l = {
				x: n,
				y: r
			}, u = await Dn(t, c), d = mn(U(i)), f = fn(d), p = l[f], m = l[d];
			if (a) {
				let e = f === "y" ? "top" : "left", t = f === "y" ? "bottom" : "right", n = p + u[e], r = p - u[t];
				p = un(n, p, r);
			}
			if (o) {
				let e = d === "y" ? "top" : "left", t = d === "y" ? "bottom" : "right", n = m + u[e], r = m - u[t];
				m = un(n, m, r);
			}
			let h = s.fn({
				...t,
				[f]: p,
				[d]: m
			});
			return {
				...h,
				data: {
					x: h.x - n,
					y: h.y - r
				}
			};
		}
	};
}, In = function(e) {
	return e === void 0 && (e = {}), {
		options: e,
		fn(t) {
			let { x: n, y: r, placement: i, rects: a, middlewareData: o } = t, { offset: s = 0, mainAxis: c = !0, crossAxis: l = !0 } = H(e, t), u = {
				x: n,
				y: r
			}, d = mn(i), f = fn(d), p = u[f], m = u[d], h = H(s, t), g = typeof h == "number" ? {
				mainAxis: h,
				crossAxis: 0
			} : {
				mainAxis: 0,
				crossAxis: 0,
				...h
			};
			if (c) {
				let e = f === "y" ? "height" : "width", t = a.reference[f] - a.floating[e] + g.mainAxis, n = a.reference[f] + a.reference[e] - g.mainAxis;
				p < t ? p = t : p > n && (p = n);
			}
			if (l) {
				let e = f === "y" ? "width" : "height", t = ["top", "left"].includes(U(i)), n = a.reference[d] - a.floating[e] + (t && o.offset?.[d] || 0) + (t ? 0 : g.crossAxis), r = a.reference[d] + a.reference[e] + (t ? 0 : o.offset?.[d] || 0) - (t ? g.crossAxis : 0);
				m < n ? m = n : m > r && (m = r);
			}
			return {
				[f]: p,
				[d]: m
			};
		}
	};
}, Ln = function(e) {
	return e === void 0 && (e = {}), {
		name: "size",
		options: e,
		async fn(t) {
			let { placement: n, rects: r, platform: i, elements: a } = t, { apply: o = () => {}, ...s } = H(e, t), c = await Dn(t, s), l = U(n), u = dn(n), d = mn(n) === "y", { width: f, height: p } = r.floating, m, h;
			l === "top" || l === "bottom" ? (m = l, h = u === (await (i.isRTL == null ? void 0 : i.isRTL(a.floating)) ? "start" : "end") ? "left" : "right") : (h = l, m = u === "end" ? "top" : "bottom");
			let g = p - c[m], _ = f - c[h], v = !t.middlewareData.shift, y = g, b = _;
			if (d) {
				let e = f - c.left - c.right;
				b = u || v ? z(_, e) : e;
			} else {
				let e = p - c.top - c.bottom;
				y = u || v ? z(g, e) : e;
			}
			if (v && !u) {
				let e = B(c.left, 0), t = B(c.right, 0), n = B(c.top, 0), r = B(c.bottom, 0);
				d ? b = f - 2 * (e !== 0 || t !== 0 ? e + t : B(c.left, c.right)) : y = p - 2 * (n !== 0 || r !== 0 ? n + r : B(c.top, c.bottom));
			}
			await o({
				...t,
				availableWidth: b,
				availableHeight: y
			});
			let x = await i.getDimensions(a.floating);
			return f !== x.width || p !== x.height ? { reset: { rects: !0 } } : {};
		}
	};
};
//#endregion
//#region ../../../node_modules/@floating-ui/react-dom/node_modules/@floating-ui/utils/dom/dist/floating-ui.utils.dom.mjs
function W(e) {
	return Rn(e) ? (e.nodeName || "").toLowerCase() : "#document";
}
function G(e) {
	return e?.ownerDocument?.defaultView || window;
}
function K(e) {
	return ((Rn(e) ? e.ownerDocument : e.document) || window.document)?.documentElement;
}
function Rn(e) {
	return e instanceof Node || e instanceof G(e).Node;
}
function q(e) {
	return e instanceof Element || e instanceof G(e).Element;
}
function J(e) {
	return e instanceof HTMLElement || e instanceof G(e).HTMLElement;
}
function zn(e) {
	return typeof ShadowRoot > "u" ? !1 : e instanceof ShadowRoot || e instanceof G(e).ShadowRoot;
}
function Bn(e) {
	let { overflow: t, overflowX: n, overflowY: r, display: i } = Y(e);
	return /auto|scroll|overlay|hidden|clip/.test(t + r + n) && !["inline", "contents"].includes(i);
}
function Vn(e) {
	return [
		"table",
		"td",
		"th"
	].includes(W(e));
}
function Hn(e) {
	let t = Wn(), n = Y(e);
	return n.transform !== "none" || n.perspective !== "none" || (n.containerType ? n.containerType !== "normal" : !1) || !t && (n.backdropFilter ? n.backdropFilter !== "none" : !1) || !t && (n.filter ? n.filter !== "none" : !1) || [
		"transform",
		"perspective",
		"filter"
	].some((e) => (n.willChange || "").includes(e)) || [
		"paint",
		"layout",
		"strict",
		"content"
	].some((e) => (n.contain || "").includes(e));
}
function Un(e) {
	let t = qn(e);
	for (; J(t) && !Gn(t);) if (Hn(t)) return t;
	else t = qn(t);
	return null;
}
function Wn() {
	return typeof CSS > "u" || !CSS.supports ? !1 : CSS.supports("-webkit-backdrop-filter", "none");
}
function Gn(e) {
	return [
		"html",
		"body",
		"#document"
	].includes(W(e));
}
function Y(e) {
	return G(e).getComputedStyle(e);
}
function Kn(e) {
	return q(e) ? {
		scrollLeft: e.scrollLeft,
		scrollTop: e.scrollTop
	} : {
		scrollLeft: e.pageXOffset,
		scrollTop: e.pageYOffset
	};
}
function qn(e) {
	if (W(e) === "html") return e;
	let t = e.assignedSlot || e.parentNode || zn(e) && e.host || K(e);
	return zn(t) ? t.host : t;
}
function Jn(e) {
	let t = qn(e);
	return Gn(t) ? e.ownerDocument ? e.ownerDocument.body : e.body : J(t) && Bn(t) ? t : Jn(t);
}
function Yn(e, t) {
	t === void 0 && (t = []);
	let n = Jn(e), r = n === e.ownerDocument?.body, i = G(n);
	return r ? t.concat(i, i.visualViewport || [], Bn(n) ? n : []) : t.concat(n, Yn(n));
}
//#endregion
//#region ../../../node_modules/@floating-ui/react-dom/node_modules/@floating-ui/dom/dist/floating-ui.dom.mjs
function Xn(e) {
	let t = Y(e), n = parseFloat(t.width) || 0, r = parseFloat(t.height) || 0, i = J(e), a = i ? e.offsetWidth : n, o = i ? e.offsetHeight : r, s = on(n) !== a || on(r) !== o;
	return s && (n = a, r = o), {
		width: n,
		height: r,
		$: s
	};
}
function Zn(e) {
	return q(e) ? e : e.contextElement;
}
function Qn(e) {
	let t = Zn(e);
	if (!J(t)) return V(1);
	let n = t.getBoundingClientRect(), { width: r, height: i, $: a } = Xn(t), o = (a ? on(n.width) : n.width) / r, s = (a ? on(n.height) : n.height) / i;
	return (!o || !Number.isFinite(o)) && (o = 1), (!s || !Number.isFinite(s)) && (s = 1), {
		x: o,
		y: s
	};
}
var $n = /*#__PURE__*/ V(0);
function er(e) {
	let t = G(e);
	return !Wn() || !t.visualViewport ? $n : {
		x: t.visualViewport.offsetLeft,
		y: t.visualViewport.offsetTop
	};
}
function tr(e, t, n) {
	return t === void 0 && (t = !1), !n || t && n !== G(e) ? !1 : t;
}
function nr(e, t, n, r) {
	t === void 0 && (t = !1), n === void 0 && (n = !1);
	let i = e.getBoundingClientRect(), a = Zn(e), o = V(1);
	t && (r ? q(r) && (o = Qn(r)) : o = Qn(e));
	let s = tr(a, n, r) ? er(a) : V(0), c = (i.left + s.x) / o.x, l = (i.top + s.y) / o.y, u = i.width / o.x, d = i.height / o.y;
	if (a) {
		let e = G(a), t = r && q(r) ? G(r) : r, n = e.frameElement;
		for (; n && r && t !== e;) {
			let e = Qn(n), t = n.getBoundingClientRect(), r = Y(n), i = t.left + (n.clientLeft + parseFloat(r.paddingLeft)) * e.x, a = t.top + (n.clientTop + parseFloat(r.paddingTop)) * e.y;
			c *= e.x, l *= e.y, u *= e.x, d *= e.y, c += i, l += a, n = G(n).frameElement;
		}
	}
	return wn({
		width: u,
		height: d,
		x: c,
		y: l
	});
}
function rr(e) {
	let { rect: t, offsetParent: n, strategy: r } = e, i = J(n), a = K(n);
	if (n === a) return t;
	let o = {
		scrollLeft: 0,
		scrollTop: 0
	}, s = V(1), c = V(0);
	if ((i || !i && r !== "fixed") && ((W(n) !== "body" || Bn(a)) && (o = Kn(n)), J(n))) {
		let e = nr(n);
		s = Qn(n), c.x = e.x + n.clientLeft, c.y = e.y + n.clientTop;
	}
	return {
		width: t.width * s.x,
		height: t.height * s.y,
		x: t.x * s.x - o.scrollLeft * s.x + c.x,
		y: t.y * s.y - o.scrollTop * s.y + c.y
	};
}
function ir(e) {
	return Array.from(e.getClientRects());
}
function ar(e) {
	return nr(K(e)).left + Kn(e).scrollLeft;
}
function or(e) {
	let t = K(e), n = Kn(e), r = e.ownerDocument.body, i = B(t.scrollWidth, t.clientWidth, r.scrollWidth, r.clientWidth), a = B(t.scrollHeight, t.clientHeight, r.scrollHeight, r.clientHeight), o = -n.scrollLeft + ar(e), s = -n.scrollTop;
	return Y(r).direction === "rtl" && (o += B(t.clientWidth, r.clientWidth) - i), {
		width: i,
		height: a,
		x: o,
		y: s
	};
}
function sr(e, t) {
	let n = G(e), r = K(e), i = n.visualViewport, a = r.clientWidth, o = r.clientHeight, s = 0, c = 0;
	if (i) {
		a = i.width, o = i.height;
		let e = Wn();
		(!e || e && t === "fixed") && (s = i.offsetLeft, c = i.offsetTop);
	}
	return {
		width: a,
		height: o,
		x: s,
		y: c
	};
}
function cr(e, t) {
	let n = nr(e, !0, t === "fixed"), r = n.top + e.clientTop, i = n.left + e.clientLeft, a = J(e) ? Qn(e) : V(1);
	return {
		width: e.clientWidth * a.x,
		height: e.clientHeight * a.y,
		x: i * a.x,
		y: r * a.y
	};
}
function lr(e, t, n) {
	let r;
	if (t === "viewport") r = sr(e, n);
	else if (t === "document") r = or(K(e));
	else if (q(t)) r = cr(t, n);
	else {
		let n = er(e);
		r = {
			...t,
			x: t.x - n.x,
			y: t.y - n.y
		};
	}
	return wn(r);
}
function ur(e, t) {
	let n = qn(e);
	return n === t || !q(n) || Gn(n) ? !1 : Y(n).position === "fixed" || ur(n, t);
}
function dr(e, t) {
	let n = t.get(e);
	if (n) return n;
	let r = Yn(e).filter((e) => q(e) && W(e) !== "body"), i = null, a = Y(e).position === "fixed", o = a ? qn(e) : e;
	for (; q(o) && !Gn(o);) {
		let t = Y(o), n = Hn(o);
		!n && t.position === "fixed" && (i = null), (a ? !n && !i : !n && t.position === "static" && i && ["absolute", "fixed"].includes(i.position) || Bn(o) && !n && ur(e, o)) ? r = r.filter((e) => e !== o) : i = t, o = qn(o);
	}
	return t.set(e, r), r;
}
function fr(e) {
	let { element: t, boundary: n, rootBoundary: r, strategy: i } = e, a = [...n === "clippingAncestors" ? dr(t, this._c) : [].concat(n), r], o = a[0], s = a.reduce((e, n) => {
		let r = lr(t, n, i);
		return e.top = B(r.top, e.top), e.right = z(r.right, e.right), e.bottom = z(r.bottom, e.bottom), e.left = B(r.left, e.left), e;
	}, lr(t, o, i));
	return {
		width: s.right - s.left,
		height: s.bottom - s.top,
		x: s.left,
		y: s.top
	};
}
function pr(e) {
	return Xn(e);
}
function mr(e, t, n) {
	let r = J(t), i = K(t), a = n === "fixed", o = nr(e, !0, a, t), s = {
		scrollLeft: 0,
		scrollTop: 0
	}, c = V(0);
	if (r || !r && !a) if ((W(t) !== "body" || Bn(i)) && (s = Kn(t)), r) {
		let e = nr(t, !0, a, t);
		c.x = e.x + t.clientLeft, c.y = e.y + t.clientTop;
	} else i && (c.x = ar(i));
	return {
		x: o.left + s.scrollLeft - c.x,
		y: o.top + s.scrollTop - c.y,
		width: o.width,
		height: o.height
	};
}
function hr(e, t) {
	return !J(e) || Y(e).position === "fixed" ? null : t ? t(e) : e.offsetParent;
}
function gr(e, t) {
	let n = G(e);
	if (!J(e)) return n;
	let r = hr(e, t);
	for (; r && Vn(r) && Y(r).position === "static";) r = hr(r, t);
	return r && (W(r) === "html" || W(r) === "body" && Y(r).position === "static" && !Hn(r)) ? n : r || Un(e) || n;
}
var _r = async function(e) {
	let { reference: t, floating: n, strategy: r } = e, i = this.getOffsetParent || gr, a = this.getDimensions;
	return {
		reference: mr(t, await i(n), r),
		floating: {
			x: 0,
			y: 0,
			...await a(n)
		}
	};
};
function vr(e) {
	return Y(e).direction === "rtl";
}
var yr = {
	convertOffsetParentRelativeRectToViewportRelativeRect: rr,
	getDocumentElement: K,
	getClippingRect: fr,
	getOffsetParent: gr,
	getElementRects: _r,
	getClientRects: ir,
	getDimensions: pr,
	getScale: Qn,
	isElement: q,
	isRTL: vr
};
function br(e, t) {
	let n = null, r, i = K(e);
	function a() {
		clearTimeout(r), n && n.disconnect(), n = null;
	}
	function o(s, c) {
		s === void 0 && (s = !1), c === void 0 && (c = 1), a();
		let { left: l, top: u, width: d, height: f } = e.getBoundingClientRect();
		if (s || t(), !d || !f) return;
		let p = sn(u), m = sn(i.clientWidth - (l + d)), h = sn(i.clientHeight - (u + f)), g = sn(l), _ = {
			rootMargin: -p + "px " + -m + "px " + -h + "px " + -g + "px",
			threshold: B(0, z(1, c)) || 1
		}, v = !0;
		function y(e) {
			let t = e[0].intersectionRatio;
			if (t !== c) {
				if (!v) return o();
				t ? o(!1, t) : r = setTimeout(() => {
					o(!1, 1e-7);
				}, 100);
			}
			v = !1;
		}
		try {
			n = new IntersectionObserver(y, {
				..._,
				root: i.ownerDocument
			});
		} catch {
			n = new IntersectionObserver(y, _);
		}
		n.observe(e);
	}
	return o(!0), a;
}
function xr(e, t, n, r) {
	r === void 0 && (r = {});
	let { ancestorScroll: i = !0, ancestorResize: a = !0, elementResize: o = typeof ResizeObserver == "function", layoutShift: s = typeof IntersectionObserver == "function", animationFrame: c = !1 } = r, l = Zn(e), u = i || a ? [...l ? Yn(l) : [], ...Yn(t)] : [];
	u.forEach((e) => {
		i && e.addEventListener("scroll", n, { passive: !0 }), a && e.addEventListener("resize", n);
	});
	let d = l && s ? br(l, n) : null, f = -1, p = null;
	o && (p = new ResizeObserver((e) => {
		let [r] = e;
		r && r.target === l && p && (p.unobserve(t), cancelAnimationFrame(f), f = requestAnimationFrame(() => {
			p && p.observe(t);
		})), n();
	}), l && !c && p.observe(l), p.observe(t));
	let m, h = c ? nr(e) : null;
	c && g();
	function g() {
		let t = nr(e);
		h && (t.x !== h.x || t.y !== h.y || t.width !== h.width || t.height !== h.height) && n(), h = t, m = requestAnimationFrame(g);
	}
	return n(), () => {
		u.forEach((e) => {
			i && e.removeEventListener("scroll", n), a && e.removeEventListener("resize", n);
		}), d && d(), p && p.disconnect(), p = null, c && cancelAnimationFrame(m);
	};
}
var Sr = (e, t, n) => {
	let r = /* @__PURE__ */ new Map(), i = {
		platform: yr,
		...n
	}, a = {
		...i.platform,
		_c: r
	};
	return En(e, t, {
		...i,
		platform: a
	});
}, Cr = (e) => {
	function t(e) {
		return {}.hasOwnProperty.call(e, "current");
	}
	return {
		name: "arrow",
		options: e,
		fn(n) {
			let { element: r, padding: i } = typeof e == "function" ? e(n) : e;
			return r && t(r) ? r.current == null ? {} : On({
				element: r.current,
				padding: i
			}).fn(n) : r ? On({
				element: r,
				padding: i
			}).fn(n) : {};
		}
	};
}, wr = typeof document < "u" ? E : T;
function Tr(e, t) {
	if (e === t) return !0;
	if (typeof e != typeof t) return !1;
	if (typeof e == "function" && e.toString() === t.toString()) return !0;
	let n, r, i;
	if (e && t && typeof e == "object") {
		if (Array.isArray(e)) {
			if (n = e.length, n != t.length) return !1;
			for (r = n; r-- !== 0;) if (!Tr(e[r], t[r])) return !1;
			return !0;
		}
		if (i = Object.keys(e), n = i.length, n !== Object.keys(t).length) return !1;
		for (r = n; r-- !== 0;) if (!{}.hasOwnProperty.call(t, i[r])) return !1;
		for (r = n; r-- !== 0;) {
			let n = i[r];
			if (!(n === "_owner" && e.$$typeof) && !Tr(e[n], t[n])) return !1;
		}
		return !0;
	}
	return e !== e && t !== t;
}
function Er(e) {
	return typeof window > "u" ? 1 : (e.ownerDocument.defaultView || window).devicePixelRatio || 1;
}
function Dr(e, t) {
	let n = Er(e);
	return Math.round(t * n) / n;
}
function Or(e) {
	let t = m.useRef(e);
	return wr(() => {
		t.current = e;
	}), t;
}
function kr(e) {
	e === void 0 && (e = {});
	let { placement: t = "bottom", strategy: n = "absolute", middleware: r = [], platform: i, elements: { reference: a, floating: o } = {}, transform: s = !0, whileElementsMounted: c, open: l } = e, [u, d] = m.useState({
		x: 0,
		y: 0,
		strategy: n,
		placement: t,
		middlewareData: {},
		isPositioned: !1
	}), [f, p] = m.useState(r);
	Tr(f, r) || p(r);
	let [h, g] = m.useState(null), [_, v] = m.useState(null), y = m.useCallback((e) => {
		e != C.current && (C.current = e, g(e));
	}, [g]), b = m.useCallback((e) => {
		e !== w.current && (w.current = e, v(e));
	}, [v]), x = a || h, S = o || _, C = m.useRef(null), w = m.useRef(null), T = m.useRef(u), E = Or(c), D = Or(i), O = m.useCallback(() => {
		if (!C.current || !w.current) return;
		let e = {
			placement: t,
			strategy: n,
			middleware: f
		};
		D.current && (e.platform = D.current), Sr(C.current, w.current, e).then((e) => {
			let t = {
				...e,
				isPositioned: !0
			};
			k.current && !Tr(T.current, t) && (T.current = t, j.flushSync(() => {
				d(t);
			}));
		});
	}, [
		f,
		t,
		n,
		D
	]);
	wr(() => {
		l === !1 && T.current.isPositioned && (T.current.isPositioned = !1, d((e) => ({
			...e,
			isPositioned: !1
		})));
	}, [l]);
	let k = m.useRef(!1);
	wr(() => (k.current = !0, () => {
		k.current = !1;
	}), []), wr(() => {
		if (x && (C.current = x), S && (w.current = S), x && S) {
			if (E.current) return E.current(x, S, O);
			O();
		}
	}, [
		x,
		S,
		O,
		E
	]);
	let A = m.useMemo(() => ({
		reference: C,
		floating: w,
		setReference: y,
		setFloating: b
	}), [y, b]), M = m.useMemo(() => ({
		reference: x,
		floating: S
	}), [x, S]), ee = m.useMemo(() => {
		let e = {
			position: n,
			left: 0,
			top: 0
		};
		if (!M.floating) return e;
		let t = Dr(M.floating, u.x), r = Dr(M.floating, u.y);
		return s ? {
			...e,
			transform: "translate(" + t + "px, " + r + "px)",
			...Er(M.floating) >= 1.5 && { willChange: "transform" }
		} : {
			position: n,
			left: t,
			top: r
		};
	}, [
		n,
		s,
		M.floating,
		u.x,
		u.y
	]);
	return m.useMemo(() => ({
		...u,
		update: O,
		refs: A,
		elements: M,
		floatingStyles: ee
	}), [
		u,
		O,
		A,
		M,
		ee
	]);
}
//#endregion
//#region ../../../node_modules/@radix-ui/react-popper/node_modules/@radix-ui/react-primitive/dist/index.mjs
var Ar = [
	"a",
	"button",
	"div",
	"form",
	"h2",
	"h3",
	"img",
	"input",
	"label",
	"li",
	"nav",
	"ol",
	"p",
	"span",
	"svg",
	"ul"
].reduce((e, t) => {
	let n = /*#__PURE__*/ b((e, n) => {
		let { asChild: r, ...i } = e, a = r ? ct : t;
		return T(() => {
			window[Symbol.for("radix-ui")] = !0;
		}, []), /*#__PURE__*/ y(a, rn({}, i, { ref: n }));
	});
	return n.displayName = `Primitive.${t}`, {
		...e,
		[t]: n
	};
}, {});
//#endregion
//#region ../../../node_modules/@radix-ui/react-popper/node_modules/@radix-ui/react-compose-refs/dist/index.mjs
function jr(e, t) {
	typeof e == "function" ? e(t) : e != null && (e.current = t);
}
function Mr(...e) {
	return (t) => e.forEach((e) => jr(e, t));
}
function Nr(...e) {
	return C(Mr(...e), e);
}
//#endregion
//#region ../../../node_modules/@radix-ui/react-popper/node_modules/@radix-ui/react-context/dist/index.mjs
function Pr(e, t = []) {
	let n = [];
	function r(t, r) {
		let i = /*#__PURE__*/ v(r), a = n.length;
		n = [...n, r];
		function o(t) {
			let { scope: n, children: r, ...o } = t, s = n?.[e][a] || i, c = D(() => o, Object.values(o));
			return /*#__PURE__*/ y(s.Provider, { value: c }, r);
		}
		function s(n, o) {
			let s = w(o?.[e][a] || i);
			if (s) return s;
			if (r !== void 0) return r;
			throw Error(`\`${n}\` must be used within \`${t}\``);
		}
		return o.displayName = t + "Provider", [o, s];
	}
	let i = () => {
		let t = n.map((e) => /*#__PURE__*/ v(e));
		return function(n) {
			let r = n?.[e] || t;
			return D(() => ({ [`__scope${e}`]: {
				...n,
				[e]: r
			} }), [n, r]);
		};
	};
	return i.scopeName = e, [r, Fr(i, ...t)];
}
function Fr(...e) {
	let t = e[0];
	if (e.length === 1) return t;
	let n = () => {
		let n = e.map((e) => ({
			useScope: e(),
			scopeName: e.scopeName
		}));
		return function(e) {
			let r = n.reduce((t, { useScope: n, scopeName: r }) => {
				let i = n(e)[`__scope${r}`];
				return {
					...t,
					...i
				};
			}, {});
			return D(() => ({ [`__scope${t.scopeName}`]: r }), [r]);
		};
	};
	return n.scopeName = t.scopeName, n;
}
//#endregion
//#region ../../../node_modules/@radix-ui/react-popper/node_modules/@radix-ui/react-use-callback-ref/dist/index.mjs
function Ir(e) {
	let t = k(e);
	return T(() => {
		t.current = e;
	}), D(() => (...e) => t.current?.call(t, ...e), []);
}
//#endregion
//#region ../../../node_modules/@radix-ui/react-popper/node_modules/@radix-ui/react-use-layout-effect/dist/index.mjs
var Lr = globalThis != null && globalThis.document ? E : () => {};
//#endregion
//#region ../../../node_modules/@radix-ui/react-popper/node_modules/@radix-ui/react-use-size/dist/index.mjs
function Rr(e) {
	let [t, n] = A(void 0);
	return Lr(() => {
		if (e) {
			n({
				width: e.offsetWidth,
				height: e.offsetHeight
			});
			let t = new ResizeObserver((t) => {
				if (!Array.isArray(t) || !t.length) return;
				let r = t[0], i, a;
				if ("borderBoxSize" in r) {
					let e = r.borderBoxSize, t = Array.isArray(e) ? e[0] : e;
					i = t.inlineSize, a = t.blockSize;
				} else i = e.offsetWidth, a = e.offsetHeight;
				n({
					width: i,
					height: a
				});
			});
			return t.observe(e, { box: "border-box" }), () => t.unobserve(e);
		} else n(void 0);
	}, [e]), t;
}
//#endregion
//#region ../../../node_modules/@radix-ui/react-popper/dist/index.mjs
var zr = "Popper", [Br, Vr] = Pr(zr), [Hr, Ur] = Br(zr), Wr = (e) => {
	let { __scopePopper: t, children: n } = e, [r, i] = A(null);
	return /*#__PURE__*/ y(Hr, {
		scope: t,
		anchor: r,
		onAnchorChange: i
	}, n);
}, Gr = "PopperAnchor", Kr = /*#__PURE__*/ b((e, t) => {
	let { __scopePopper: n, virtualRef: r, ...i } = e, a = Ur(Gr, n), o = k(null), s = Nr(t, o);
	return T(() => {
		a.onAnchorChange(r?.current || o.current);
	}), r ? null : /*#__PURE__*/ y(Ar.div, rn({}, i, { ref: s }));
}), qr = "PopperContent", [Jr, Yr] = Br(qr), Xr = /*#__PURE__*/ b((e, t) => {
	var n;
	let { __scopePopper: r, side: i = "bottom", sideOffset: a = 0, align: o = "center", alignOffset: s = 0, arrowPadding: c = 0, avoidCollisions: l = !0, collisionBoundary: u = [], collisionPadding: d = 0, sticky: f = "partial", hideWhenDetached: p = !1, updatePositionStrategy: m = "optimized", onPlaced: h, ...g } = e, _ = Ur(qr, r), [v, b] = A(null), x = Nr(t, (e) => b(e)), [S, C] = A(null), w = Rr(S), T = w?.width ?? 0, E = w?.height ?? 0, D = i + (o === "center" ? "" : "-" + o), O = typeof d == "number" ? d : {
		top: 0,
		right: 0,
		bottom: 0,
		left: 0,
		...d
	}, k = Array.isArray(u) ? u : [u], j = k.length > 0, M = {
		padding: O,
		boundary: k.filter(Zr),
		altBoundary: j
	}, { refs: ee, floatingStyles: N, placement: P, isPositioned: F, middlewareData: I } = kr({
		strategy: "fixed",
		placement: D,
		whileElementsMounted: (...e) => xr(...e, { animationFrame: m === "always" }),
		elements: { reference: _.anchor },
		middleware: [
			Pn({
				mainAxis: a + E,
				alignmentAxis: s
			}),
			l && Fn({
				mainAxis: !0,
				crossAxis: !1,
				limiter: f === "partial" ? In() : void 0,
				...M
			}),
			l && kn({ ...M }),
			Ln({
				...M,
				apply: ({ elements: e, rects: t, availableWidth: n, availableHeight: r }) => {
					let { width: i, height: a } = t.reference, o = e.floating.style;
					o.setProperty("--radix-popper-available-width", `${n}px`), o.setProperty("--radix-popper-available-height", `${r}px`), o.setProperty("--radix-popper-anchor-width", `${i}px`), o.setProperty("--radix-popper-anchor-height", `${a}px`);
				}
			}),
			S && Cr({
				element: S,
				padding: c
			}),
			Qr({
				arrowWidth: T,
				arrowHeight: E
			}),
			p && Mn({
				strategy: "referenceHidden",
				...M
			})
		]
	}), [te, ne] = $r(P), re = Ir(h);
	Lr(() => {
		F && re?.();
	}, [F, re]);
	let ie = I.arrow?.x, ae = I.arrow?.y, oe = I.arrow?.centerOffset !== 0, [se, ce] = A();
	return Lr(() => {
		v && ce(window.getComputedStyle(v).zIndex);
	}, [v]), /*#__PURE__*/ y("div", {
		ref: ee.setFloating,
		"data-radix-popper-content-wrapper": "",
		style: {
			...N,
			transform: F ? N.transform : "translate(0, -200%)",
			minWidth: "max-content",
			zIndex: se,
			"--radix-popper-transform-origin": [I.transformOrigin?.x, I.transformOrigin?.y].join(" ")
		},
		dir: e.dir
	}, /*#__PURE__*/ y(Jr, {
		scope: r,
		placedSide: te,
		onArrowChange: C,
		arrowX: ie,
		arrowY: ae,
		shouldHideArrow: oe
	}, /*#__PURE__*/ y(Ar.div, rn({
		"data-side": te,
		"data-align": ne
	}, g, {
		ref: x,
		style: {
			...g.style,
			animation: F ? void 0 : "none",
			opacity: (n = I.hide) != null && n.referenceHidden ? 0 : void 0
		}
	}))));
});
function Zr(e) {
	return e !== null;
}
var Qr = (e) => ({
	name: "transformOrigin",
	options: e,
	fn(t) {
		let { placement: n, rects: r, middlewareData: i } = t, a = i.arrow?.centerOffset !== 0, o = a ? 0 : e.arrowWidth, s = a ? 0 : e.arrowHeight, [c, l] = $r(n), u = {
			start: "0%",
			center: "50%",
			end: "100%"
		}[l], d = (i.arrow?.x ?? 0) + o / 2, f = (i.arrow?.y ?? 0) + s / 2, p = "", m = "";
		return c === "bottom" ? (p = a ? u : `${d}px`, m = `${-s}px`) : c === "top" ? (p = a ? u : `${d}px`, m = `${r.floating.height + s}px`) : c === "right" ? (p = `${-s}px`, m = a ? u : `${f}px`) : c === "left" && (p = `${r.floating.width + s}px`, m = a ? u : `${f}px`), { data: {
			x: p,
			y: m
		} };
	}
});
function $r(e) {
	let [t, n = "center"] = e.split("-");
	return [t, n];
}
var ei = Wr, ti = Kr, ni = Xr;
//#endregion
//#region ../../../node_modules/@radix-ui/react-portal/node_modules/@babel/runtime/helpers/esm/extends.js
function ri() {
	return ri = Object.assign ? Object.assign.bind() : function(e) {
		for (var t = 1; t < arguments.length; t++) {
			var n = arguments[t];
			for (var r in n) Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
		}
		return e;
	}, ri.apply(this, arguments);
}
//#endregion
//#region ../../../node_modules/@radix-ui/react-portal/node_modules/@radix-ui/react-primitive/dist/index.mjs
var ii = [
	"a",
	"button",
	"div",
	"form",
	"h2",
	"h3",
	"img",
	"input",
	"label",
	"li",
	"nav",
	"ol",
	"p",
	"span",
	"svg",
	"ul"
].reduce((e, t) => {
	let n = /*#__PURE__*/ b((e, n) => {
		let { asChild: r, ...i } = e, a = r ? ct : t;
		return T(() => {
			window[Symbol.for("radix-ui")] = !0;
		}, []), /*#__PURE__*/ y(a, ri({}, i, { ref: n }));
	});
	return n.displayName = `Primitive.${t}`, {
		...e,
		[t]: n
	};
}, {}), ai = /*#__PURE__*/ b((e, t) => {
	let { container: n = globalThis == null ? void 0 : globalThis.document?.body, ...r } = e;
	return n ? /*#__PURE__*/ M.createPortal(/*#__PURE__*/ y(ii.div, ri({}, r, { ref: t })), n) : null;
}), oi = globalThis != null && globalThis.document ? E : () => {};
//#endregion
//#region ../../../node_modules/@radix-ui/react-popover/node_modules/@radix-ui/react-presence/dist/index.mjs
function si(e, t) {
	return O((e, n) => t[e][n] ?? e, e);
}
var ci = (e) => {
	let { present: t, children: n } = e, r = li(t), i = typeof n == "function" ? n({ present: r.isPresent }) : h.only(n), a = et(r.ref, i.ref);
	return typeof n == "function" || r.isPresent ? /*#__PURE__*/ _(i, { ref: a }) : null;
};
ci.displayName = "Presence";
function li(e) {
	let [t, n] = A(), r = k({}), i = k(e), a = k("none"), [o, s] = si(e ? "mounted" : "unmounted", {
		mounted: {
			UNMOUNT: "unmounted",
			ANIMATION_OUT: "unmountSuspended"
		},
		unmountSuspended: {
			MOUNT: "mounted",
			ANIMATION_END: "unmounted"
		},
		unmounted: { MOUNT: "mounted" }
	});
	return T(() => {
		let e = ui(r.current);
		a.current = o === "mounted" ? e : "none";
	}, [o]), oi(() => {
		let t = r.current, n = i.current;
		if (n !== e) {
			let r = a.current, o = ui(t);
			e ? s("MOUNT") : o === "none" || t?.display === "none" ? s("UNMOUNT") : s(n && r !== o ? "ANIMATION_OUT" : "UNMOUNT"), i.current = e;
		}
	}, [e, s]), oi(() => {
		if (t) {
			let e = (e) => {
				let n = ui(r.current).includes(e.animationName);
				e.target === t && n && ee(() => s("ANIMATION_END"));
			}, n = (e) => {
				e.target === t && (a.current = ui(r.current));
			};
			return t.addEventListener("animationstart", n), t.addEventListener("animationcancel", e), t.addEventListener("animationend", e), () => {
				t.removeEventListener("animationstart", n), t.removeEventListener("animationcancel", e), t.removeEventListener("animationend", e);
			};
		} else s("ANIMATION_END");
	}, [t, s]), {
		isPresent: ["mounted", "unmountSuspended"].includes(o),
		ref: C((e) => {
			e && (r.current = getComputedStyle(e)), n(e);
		}, [])
	};
}
function ui(e) {
	return e?.animationName || "none";
}
//#endregion
//#region ../../../node_modules/@radix-ui/react-popover/node_modules/@radix-ui/react-primitive/dist/index.mjs
var di = [
	"a",
	"button",
	"div",
	"form",
	"h2",
	"h3",
	"img",
	"input",
	"label",
	"li",
	"nav",
	"ol",
	"p",
	"span",
	"svg",
	"ul"
].reduce((e, t) => {
	let n = /*#__PURE__*/ b((e, n) => {
		let { asChild: r, ...i } = e, a = r ? ct : t;
		return T(() => {
			window[Symbol.for("radix-ui")] = !0;
		}, []), /*#__PURE__*/ y(a, L({}, i, { ref: n }));
	});
	return n.displayName = `Primitive.${t}`, {
		...e,
		[t]: n
	};
}, {});
//#endregion
//#region ../../../node_modules/@radix-ui/react-popover/node_modules/@radix-ui/react-use-callback-ref/dist/index.mjs
function fi(e) {
	let t = k(e);
	return T(() => {
		t.current = e;
	}), D(() => (...e) => t.current?.call(t, ...e), []);
}
//#endregion
//#region ../../../node_modules/@radix-ui/react-popover/node_modules/@radix-ui/react-use-controllable-state/dist/index.mjs
function pi({ prop: e, defaultProp: t, onChange: n = () => {} }) {
	let [r, i] = mi({
		defaultProp: t,
		onChange: n
	}), a = e !== void 0, o = a ? e : r, s = fi(n);
	return [o, C((t) => {
		if (a) {
			let n = typeof t == "function" ? t(e) : t;
			n !== e && s(n);
		} else i(t);
	}, [
		a,
		e,
		i,
		s
	])];
}
function mi({ defaultProp: e, onChange: t }) {
	let n = A(e), [r] = n, i = k(r), a = fi(t);
	return T(() => {
		i.current !== r && (a(r), i.current = r);
	}, [
		r,
		i,
		a
	]), n;
}
//#endregion
//#region ../../../node_modules/aria-hidden/dist/es2015/index.js
var hi = function(e) {
	return typeof document > "u" ? null : (Array.isArray(e) ? e[0] : e).ownerDocument.body;
}, gi = /* @__PURE__ */ new WeakMap(), _i = /* @__PURE__ */ new WeakMap(), vi = {}, yi = 0, bi = function(e) {
	return e && (e.host || bi(e.parentNode));
}, xi = function(e, t) {
	return t.map(function(t) {
		if (e.contains(t)) return t;
		var n = bi(t);
		return n && e.contains(n) ? n : (console.error("aria-hidden", t, "in not contained inside", e, ". Doing nothing"), null);
	}).filter(function(e) {
		return !!e;
	});
}, Si = function(e, t, n, r) {
	var i = xi(t, Array.isArray(e) ? e : [e]);
	vi[n] || (vi[n] = /* @__PURE__ */ new WeakMap());
	var a = vi[n], o = [], s = /* @__PURE__ */ new Set(), c = new Set(i), l = function(e) {
		!e || s.has(e) || (s.add(e), l(e.parentNode));
	};
	i.forEach(l);
	var u = function(e) {
		!e || c.has(e) || Array.prototype.forEach.call(e.children, function(e) {
			if (s.has(e)) u(e);
			else {
				var t = e.getAttribute(r), i = t !== null && t !== "false", c = (gi.get(e) || 0) + 1, l = (a.get(e) || 0) + 1;
				gi.set(e, c), a.set(e, l), o.push(e), c === 1 && i && _i.set(e, !0), l === 1 && e.setAttribute(n, "true"), i || e.setAttribute(r, "true");
			}
		});
	};
	return u(t), s.clear(), yi++, function() {
		o.forEach(function(e) {
			var t = gi.get(e) - 1, i = a.get(e) - 1;
			gi.set(e, t), a.set(e, i), t || (_i.has(e) || e.removeAttribute(r), _i.delete(e)), i || e.removeAttribute(n);
		}), yi--, yi || (gi = /* @__PURE__ */ new WeakMap(), gi = /* @__PURE__ */ new WeakMap(), _i = /* @__PURE__ */ new WeakMap(), vi = {});
	};
}, Ci = function(e, t, n) {
	n === void 0 && (n = "data-aria-hidden");
	var r = Array.from(Array.isArray(e) ? e : [e]), i = t || hi(e);
	return i ? (r.push.apply(r, Array.from(i.querySelectorAll("[aria-live]"))), Si(r, i, n, "aria-hidden")) : function() {
		return null;
	};
}, X = function() {
	return X = Object.assign || function(e) {
		for (var t, n = 1, r = arguments.length; n < r; n++) for (var i in t = arguments[n], t) Object.prototype.hasOwnProperty.call(t, i) && (e[i] = t[i]);
		return e;
	}, X.apply(this, arguments);
};
function wi(e, t) {
	var n = {};
	for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
	if (e != null && typeof Object.getOwnPropertySymbols == "function") for (var i = 0, r = Object.getOwnPropertySymbols(e); i < r.length; i++) t.indexOf(r[i]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[i]) && (n[r[i]] = e[r[i]]);
	return n;
}
function Ti(e, t, n) {
	if (n || arguments.length === 2) for (var r = 0, i = t.length, a; r < i; r++) (a || !(r in t)) && (a ||= Array.prototype.slice.call(t, 0, r), a[r] = t[r]);
	return e.concat(a || Array.prototype.slice.call(t));
}
//#endregion
//#region ../../../node_modules/react-remove-scroll/node_modules/react-remove-scroll-bar/dist/es2015/constants.js
var Ei = "right-scroll-bar-position", Di = "width-before-scroll-bar", Oi = "with-scroll-bars-hidden", ki = "--removed-body-scroll-bar-size";
//#endregion
//#region ../../../node_modules/use-callback-ref/dist/es2015/assignRef.js
function Ai(e, t) {
	return typeof e == "function" ? e(t) : e && (e.current = t), e;
}
//#endregion
//#region ../../../node_modules/use-callback-ref/dist/es2015/useRef.js
function ji(e, t) {
	var n = A(function() {
		return {
			value: e,
			callback: t,
			facade: {
				get current() {
					return n.value;
				},
				set current(e) {
					var t = n.value;
					t !== e && (n.value = e, n.callback(e, t));
				}
			}
		};
	})[0];
	return n.callback = t, n.facade;
}
//#endregion
//#region ../../../node_modules/use-callback-ref/dist/es2015/useMergeRef.js
function Mi(e, t) {
	return ji(t || null, function(t) {
		return e.forEach(function(e) {
			return Ai(e, t);
		});
	});
}
//#endregion
//#region ../../../node_modules/use-sidecar/dist/es2015/medium.js
function Ni(e) {
	return e;
}
function Pi(e, t) {
	t === void 0 && (t = Ni);
	var n = [], r = !1;
	return {
		read: function() {
			if (r) throw Error("Sidecar: could not `read` from an `assigned` medium. `read` could be used only with `useMedium`.");
			return n.length ? n[n.length - 1] : e;
		},
		useMedium: function(e) {
			var i = t(e, r);
			return n.push(i), function() {
				n = n.filter(function(e) {
					return e !== i;
				});
			};
		},
		assignSyncMedium: function(e) {
			for (r = !0; n.length;) {
				var t = n;
				n = [], t.forEach(e);
			}
			n = {
				push: function(t) {
					return e(t);
				},
				filter: function() {
					return n;
				}
			};
		},
		assignMedium: function(e) {
			r = !0;
			var t = [];
			if (n.length) {
				var i = n;
				n = [], i.forEach(e), t = n;
			}
			var a = function() {
				var n = t;
				t = [], n.forEach(e);
			}, o = function() {
				return Promise.resolve().then(a);
			};
			o(), n = {
				push: function(e) {
					t.push(e), o();
				},
				filter: function(e) {
					return t = t.filter(e), n;
				}
			};
		}
	};
}
function Fi(e) {
	e === void 0 && (e = {});
	var t = Pi(null);
	return t.options = X({
		async: !0,
		ssr: !1
	}, e), t;
}
//#endregion
//#region ../../../node_modules/use-sidecar/dist/es2015/exports.js
var Ii = function(e) {
	var t = e.sideCar, n = wi(e, ["sideCar"]);
	if (!t) throw Error("Sidecar: please provide `sideCar` property to import the right car");
	var r = t.read();
	if (!r) throw Error("Sidecar medium not found");
	return m.createElement(r, X({}, n));
};
Ii.isSideCarExport = !0;
function Li(e, t) {
	return e.useMedium(t), Ii;
}
//#endregion
//#region ../../../node_modules/react-remove-scroll/dist/es2015/medium.js
var Ri = Fi(), zi = function() {}, Bi = m.forwardRef(function(e, t) {
	var n = m.useRef(null), r = m.useState({
		onScrollCapture: zi,
		onWheelCapture: zi,
		onTouchMoveCapture: zi
	}), i = r[0], a = r[1], o = e.forwardProps, s = e.children, c = e.className, l = e.removeScrollBar, u = e.enabled, d = e.shards, f = e.sideCar, p = e.noIsolation, h = e.inert, g = e.allowPinchZoom, _ = e.as, v = _ === void 0 ? "div" : _, y = wi(e, [
		"forwardProps",
		"children",
		"className",
		"removeScrollBar",
		"enabled",
		"shards",
		"sideCar",
		"noIsolation",
		"inert",
		"allowPinchZoom",
		"as"
	]), b = f, x = Mi([n, t]), S = X(X({}, y), i);
	return m.createElement(m.Fragment, null, u && m.createElement(b, {
		sideCar: Ri,
		removeScrollBar: l,
		shards: d,
		noIsolation: p,
		inert: h,
		setCallbacks: a,
		allowPinchZoom: !!g,
		lockRef: n
	}), o ? m.cloneElement(m.Children.only(s), X(X({}, S), { ref: x })) : m.createElement(v, X({}, S, {
		className: c,
		ref: x
	}), s));
});
Bi.defaultProps = {
	enabled: !0,
	removeScrollBar: !0,
	inert: !1
}, Bi.classNames = {
	fullWidth: Di,
	zeroRight: Ei
};
//#endregion
//#region ../../../node_modules/get-nonce/dist/es2015/index.js
var Vi, Hi = function() {
	if (Vi) return Vi;
	if (typeof __webpack_nonce__ < "u") return __webpack_nonce__;
};
//#endregion
//#region ../../../node_modules/react-style-singleton/dist/es2015/singleton.js
function Ui() {
	if (!document) return null;
	var e = document.createElement("style");
	e.type = "text/css";
	var t = Hi();
	return t && e.setAttribute("nonce", t), e;
}
function Wi(e, t) {
	e.styleSheet ? e.styleSheet.cssText = t : e.appendChild(document.createTextNode(t));
}
function Gi(e) {
	(document.head || document.getElementsByTagName("head")[0]).appendChild(e);
}
var Ki = function() {
	var e = 0, t = null;
	return {
		add: function(n) {
			e == 0 && (t = Ui()) && (Wi(t, n), Gi(t)), e++;
		},
		remove: function() {
			e--, !e && t && (t.parentNode && t.parentNode.removeChild(t), t = null);
		}
	};
}, qi = function() {
	var e = Ki();
	return function(t, n) {
		m.useEffect(function() {
			return e.add(t), function() {
				e.remove();
			};
		}, [t && n]);
	};
}, Ji = function() {
	var e = qi();
	return function(t) {
		var n = t.styles, r = t.dynamic;
		return e(n, r), null;
	};
}, Yi = {
	left: 0,
	top: 0,
	right: 0,
	gap: 0
}, Xi = function(e) {
	return parseInt(e || "", 10) || 0;
}, Zi = function(e) {
	var t = window.getComputedStyle(document.body), n = t[e === "padding" ? "paddingLeft" : "marginLeft"], r = t[e === "padding" ? "paddingTop" : "marginTop"], i = t[e === "padding" ? "paddingRight" : "marginRight"];
	return [
		Xi(n),
		Xi(r),
		Xi(i)
	];
}, Qi = function(e) {
	if (e === void 0 && (e = "margin"), typeof window > "u") return Yi;
	var t = Zi(e), n = document.documentElement.clientWidth, r = window.innerWidth;
	return {
		left: t[0],
		top: t[1],
		right: t[2],
		gap: Math.max(0, r - n + t[2] - t[0])
	};
}, $i = Ji(), ea = function(e, t, n, r) {
	var i = e.left, a = e.top, o = e.right, s = e.gap;
	return n === void 0 && (n = "margin"), `
  .${Oi} {
   overflow: hidden ${r};
   padding-right: ${s}px ${r};
  }
  body {
    overflow: hidden ${r};
    overscroll-behavior: contain;
    ${[
		t && `position: relative ${r};`,
		n === "margin" && `
    padding-left: ${i}px;
    padding-top: ${a}px;
    padding-right: ${o}px;
    margin-left:0;
    margin-top:0;
    margin-right: ${s}px ${r};
    `,
		n === "padding" && `padding-right: ${s}px ${r};`
	].filter(Boolean).join("")}
  }
  
  .${Ei} {
    right: ${s}px ${r};
  }
  
  .${Di} {
    margin-right: ${s}px ${r};
  }
  
  .${Ei} .${Ei} {
    right: 0 ${r};
  }
  
  .${Di} .${Di} {
    margin-right: 0 ${r};
  }
  
  body {
    ${ki}: ${s}px;
  }
`;
}, ta = function(e) {
	var t = e.noRelative, n = e.noImportant, r = e.gapMode, i = r === void 0 ? "margin" : r, a = m.useMemo(function() {
		return Qi(i);
	}, [i]);
	return m.createElement($i, { styles: ea(a, !t, i, n ? "" : "!important") });
}, na = !1;
if (typeof window < "u") try {
	var ra = Object.defineProperty({}, "passive", { get: function() {
		return na = !0, !0;
	} });
	window.addEventListener("test", ra, ra), window.removeEventListener("test", ra, ra);
} catch {
	na = !1;
}
var ia = na ? { passive: !1 } : !1, aa = function(e) {
	return e.tagName === "TEXTAREA";
}, oa = function(e, t) {
	var n = window.getComputedStyle(e);
	return n[t] !== "hidden" && !(n.overflowY === n.overflowX && !aa(e) && n[t] === "visible");
}, sa = function(e) {
	return oa(e, "overflowY");
}, ca = function(e) {
	return oa(e, "overflowX");
}, la = function(e, t) {
	var n = t;
	do {
		if (typeof ShadowRoot < "u" && n instanceof ShadowRoot && (n = n.host), fa(e, n)) {
			var r = pa(e, n);
			if (r[1] > r[2]) return !0;
		}
		n = n.parentNode;
	} while (n && n !== document.body);
	return !1;
}, ua = function(e) {
	return [
		e.scrollTop,
		e.scrollHeight,
		e.clientHeight
	];
}, da = function(e) {
	return [
		e.scrollLeft,
		e.scrollWidth,
		e.clientWidth
	];
}, fa = function(e, t) {
	return e === "v" ? sa(t) : ca(t);
}, pa = function(e, t) {
	return e === "v" ? ua(t) : da(t);
}, ma = function(e, t) {
	return e === "h" && t === "rtl" ? -1 : 1;
}, ha = function(e, t, n, r, i) {
	var a = ma(e, window.getComputedStyle(t).direction), o = a * r, s = n.target, c = t.contains(s), l = !1, u = o > 0, d = 0, f = 0;
	do {
		var p = pa(e, s), m = p[0], h = p[1] - p[2] - a * m;
		(m || h) && fa(e, s) && (d += h, f += m), s = s.parentNode;
	} while (!c && s !== document.body || c && (t.contains(s) || t === s));
	return (u && (i && d === 0 || !i && o > d) || !u && (i && f === 0 || !i && -o > f)) && (l = !0), l;
}, ga = function(e) {
	return "changedTouches" in e ? [e.changedTouches[0].clientX, e.changedTouches[0].clientY] : [0, 0];
}, _a = function(e) {
	return [e.deltaX, e.deltaY];
}, va = function(e) {
	return e && "current" in e ? e.current : e;
}, ya = function(e, t) {
	return e[0] === t[0] && e[1] === t[1];
}, ba = function(e) {
	return `
  .block-interactivity-${e} {pointer-events: none;}
  .allow-interactivity-${e} {pointer-events: all;}
`;
}, xa = 0, Sa = [];
function Ca(e) {
	var t = m.useRef([]), n = m.useRef([0, 0]), r = m.useRef(), i = m.useState(xa++)[0], a = m.useState(function() {
		return Ji();
	})[0], o = m.useRef(e);
	m.useEffect(function() {
		o.current = e;
	}, [e]), m.useEffect(function() {
		if (e.inert) {
			document.body.classList.add(`block-interactivity-${i}`);
			var t = Ti([e.lockRef.current], (e.shards || []).map(va), !0).filter(Boolean);
			return t.forEach(function(e) {
				return e.classList.add(`allow-interactivity-${i}`);
			}), function() {
				document.body.classList.remove(`block-interactivity-${i}`), t.forEach(function(e) {
					return e.classList.remove(`allow-interactivity-${i}`);
				});
			};
		}
	}, [
		e.inert,
		e.lockRef.current,
		e.shards
	]);
	var s = m.useCallback(function(e, t) {
		if ("touches" in e && e.touches.length === 2) return !o.current.allowPinchZoom;
		var i = ga(e), a = n.current, s = "deltaX" in e ? e.deltaX : a[0] - i[0], c = "deltaY" in e ? e.deltaY : a[1] - i[1], l, u = e.target, d = Math.abs(s) > Math.abs(c) ? "h" : "v";
		if ("touches" in e && d === "h" && u.type === "range") return !1;
		var f = la(d, u);
		if (!f) return !0;
		if (f ? l = d : (l = d === "v" ? "h" : "v", f = la(d, u)), !f) return !1;
		if (!r.current && "changedTouches" in e && (s || c) && (r.current = l), !l) return !0;
		var p = r.current || l;
		return ha(p, t, e, p === "h" ? s : c, !0);
	}, []), c = m.useCallback(function(e) {
		var n = e;
		if (!(!Sa.length || Sa[Sa.length - 1] !== a)) {
			var r = "deltaY" in n ? _a(n) : ga(n), i = t.current.filter(function(e) {
				return e.name === n.type && e.target === n.target && ya(e.delta, r);
			})[0];
			if (i && i.should) {
				n.cancelable && n.preventDefault();
				return;
			}
			if (!i) {
				var c = (o.current.shards || []).map(va).filter(Boolean).filter(function(e) {
					return e.contains(n.target);
				});
				(c.length > 0 ? s(n, c[0]) : !o.current.noIsolation) && n.cancelable && n.preventDefault();
			}
		}
	}, []), l = m.useCallback(function(e, n, r, i) {
		var a = {
			name: e,
			delta: n,
			target: r,
			should: i
		};
		t.current.push(a), setTimeout(function() {
			t.current = t.current.filter(function(e) {
				return e !== a;
			});
		}, 1);
	}, []), u = m.useCallback(function(e) {
		n.current = ga(e), r.current = void 0;
	}, []), d = m.useCallback(function(t) {
		l(t.type, _a(t), t.target, s(t, e.lockRef.current));
	}, []), f = m.useCallback(function(t) {
		l(t.type, ga(t), t.target, s(t, e.lockRef.current));
	}, []);
	m.useEffect(function() {
		return Sa.push(a), e.setCallbacks({
			onScrollCapture: d,
			onWheelCapture: d,
			onTouchMoveCapture: f
		}), document.addEventListener("wheel", c, ia), document.addEventListener("touchmove", c, ia), document.addEventListener("touchstart", u, ia), function() {
			Sa = Sa.filter(function(e) {
				return e !== a;
			}), document.removeEventListener("wheel", c, ia), document.removeEventListener("touchmove", c, ia), document.removeEventListener("touchstart", u, ia);
		};
	}, []);
	var p = e.removeScrollBar, h = e.inert;
	return m.createElement(m.Fragment, null, h ? m.createElement(a, { styles: ba(i) }) : null, p ? m.createElement(ta, { gapMode: "margin" }) : null);
}
//#endregion
//#region ../../../node_modules/react-remove-scroll/dist/es2015/sidecar.js
var wa = Li(Ri, Ca), Ta = m.forwardRef(function(e, t) {
	return m.createElement(Bi, X({}, e, {
		ref: t,
		sideCar: wa
	}));
});
Ta.classNames = Bi.classNames;
//#endregion
//#region ../../../node_modules/@radix-ui/react-popover/dist/index.mjs
var Ea = "Popover", [Da, Oa] = tt(Ea, [Vr]), ka = Vr(), [Aa, ja] = Da(Ea), Ma = (e) => {
	let { __scopePopover: t, children: n, open: r, defaultOpen: i, onOpenChange: a, modal: o = !1 } = e, s = ka(t), c = k(null), [l, u] = A(!1), [d = !1, f] = pi({
		prop: r,
		defaultProp: i,
		onChange: a
	});
	return /*#__PURE__*/ y(ei, s, /*#__PURE__*/ y(Aa, {
		scope: t,
		contentId: nn(),
		triggerRef: c,
		open: d,
		onOpenChange: f,
		onOpenToggle: C(() => f((e) => !e), [f]),
		hasCustomAnchor: l,
		onCustomAnchorAdd: C(() => u(!0), []),
		onCustomAnchorRemove: C(() => u(!1), []),
		modal: o
	}, n));
}, Na = "PopoverTrigger", Pa = /*#__PURE__*/ b((e, t) => {
	let { __scopePopover: n, ...r } = e, i = ja(Na, n), a = ka(n), o = et(t, i.triggerRef), s = /*#__PURE__*/ y(di.button, L({
		type: "button",
		"aria-haspopup": "dialog",
		"aria-expanded": i.open,
		"aria-controls": i.contentId,
		"data-state": Wa(i.open)
	}, r, {
		ref: o,
		onClick: Ze(e.onClick, i.onOpenToggle)
	}));
	return i.hasCustomAnchor ? s : /*#__PURE__*/ y(ti, L({ asChild: !0 }, a), s);
}), Fa = "PopoverPortal", [Ia, La] = Da(Fa, { forceMount: void 0 }), Ra = (e) => {
	let { __scopePopover: t, forceMount: n, children: r, container: i } = e, a = ja(Fa, t);
	return /*#__PURE__*/ y(Ia, {
		scope: t,
		forceMount: n
	}, /*#__PURE__*/ y(ci, { present: n || a.open }, /*#__PURE__*/ y(ai, {
		asChild: !0,
		container: i
	}, r)));
}, za = "PopoverContent", Ba = /*#__PURE__*/ b((e, t) => {
	let n = La(za, e.__scopePopover), { forceMount: r = n.forceMount, ...i } = e, a = ja(za, e.__scopePopover);
	return /*#__PURE__*/ y(ci, { present: r || a.open }, a.modal ? /*#__PURE__*/ y(Va, L({}, i, { ref: t })) : /*#__PURE__*/ y(Ha, L({}, i, { ref: t })));
}), Va = /*#__PURE__*/ b((e, t) => {
	let n = ja(za, e.__scopePopover), r = k(null), i = et(t, r), a = k(!1);
	return T(() => {
		let e = r.current;
		if (e) return Ci(e);
	}, []), /*#__PURE__*/ y(Ta, {
		as: ct,
		allowPinchZoom: !0
	}, /*#__PURE__*/ y(Ua, L({}, e, {
		ref: i,
		trapFocus: n.open,
		disableOutsidePointerEvents: !0,
		onCloseAutoFocus: Ze(e.onCloseAutoFocus, (e) => {
			var t;
			e.preventDefault(), a.current || (t = n.triggerRef.current) == null || t.focus();
		}),
		onPointerDownOutside: Ze(e.onPointerDownOutside, (e) => {
			let t = e.detail.originalEvent, n = t.button === 0 && t.ctrlKey === !0, r = t.button === 2 || n;
			a.current = r;
		}, { checkForDefaultPrevented: !1 }),
		onFocusOutside: Ze(e.onFocusOutside, (e) => e.preventDefault(), { checkForDefaultPrevented: !1 })
	})));
}), Ha = /*#__PURE__*/ b((e, t) => {
	let n = ja(za, e.__scopePopover), r = k(!1), i = k(!1);
	return /*#__PURE__*/ y(Ua, L({}, e, {
		ref: t,
		trapFocus: !1,
		disableOutsidePointerEvents: !1,
		onCloseAutoFocus: (t) => {
			var a;
			if ((a = e.onCloseAutoFocus) == null || a.call(e, t), !t.defaultPrevented) {
				var o;
				r.current || (o = n.triggerRef.current) == null || o.focus(), t.preventDefault();
			}
			r.current = !1, i.current = !1;
		},
		onInteractOutside: (t) => {
			var a;
			(a = e.onInteractOutside) == null || a.call(e, t), t.defaultPrevented || (r.current = !0, t.detail.originalEvent.type === "pointerdown" && (i.current = !0));
			let o = t.target;
			n.triggerRef.current?.contains(o) && t.preventDefault(), t.detail.originalEvent.type === "focusin" && i.current && t.preventDefault();
		}
	}));
}), Ua = /*#__PURE__*/ b((e, t) => {
	let { __scopePopover: n, trapFocus: r, onOpenAutoFocus: i, onCloseAutoFocus: a, disableOutsidePointerEvents: o, onEscapeKeyDown: s, onPointerDownOutside: c, onFocusOutside: l, onInteractOutside: u, ...d } = e, f = ja(za, n), p = ka(n);
	return jt(), /*#__PURE__*/ y(Ht, {
		asChild: !0,
		loop: !0,
		trapped: r,
		onMountAutoFocus: i,
		onUnmountAutoFocus: a
	}, /*#__PURE__*/ y(Tt, {
		asChild: !0,
		disableOutsidePointerEvents: o,
		onInteractOutside: u,
		onEscapeKeyDown: s,
		onPointerDownOutside: c,
		onFocusOutside: l,
		onDismiss: () => f.onOpenChange(!1)
	}, /*#__PURE__*/ y(ni, L({
		"data-state": Wa(f.open),
		role: "dialog",
		id: f.contentId
	}, p, d, {
		ref: t,
		style: {
			...d.style,
			"--radix-popover-content-transform-origin": "var(--radix-popper-transform-origin)",
			"--radix-popover-content-available-width": "var(--radix-popper-available-width)",
			"--radix-popover-content-available-height": "var(--radix-popper-available-height)",
			"--radix-popover-trigger-width": "var(--radix-popper-anchor-width)",
			"--radix-popover-trigger-height": "var(--radix-popper-anchor-height)"
		}
	}))));
});
function Wa(e) {
	return e ? "open" : "closed";
}
var Ga = Ma, Ka = Pa, qa = Ra, Ja = Ba, Ya = {
	tooltip: "_tooltip_5svgn_1",
	popover: "_popover_5svgn_5"
}, Xa = ({ actions: e, buttonProps: { onClick: t, ...n } = {}, side: r = "bottom", align: a = "end" }) => {
	let [o, c] = A(!1), u = C((e) => {
		e.stopPropagation(), t?.(e);
	}, [t]);
	if (!e.length) return null;
	let d = (e, t) => {
		switch (e.type) {
			case "button":
			case "link": {
				let n = /* @__PURE__ */ P(i.Item, {
					icon: e.icon,
					onClick: (t) => {
						e.onClick?.(t), c(!1);
					},
					isDisabled: e.disabled ?? !1,
					children: /* @__PURE__ */ F(s, {
						as: "span",
						flexDirection: "column",
						alignItems: "flex-start",
						gap: "2px",
						children: [/* @__PURE__ */ P("span", { children: e.label }), e.description && /* @__PURE__ */ P(f.Paragraph, {
							as: "span",
							variant: "4",
							subdued: !0,
							children: e.description
						})]
					})
				});
				return /* @__PURE__ */ P(p, {
					className: Ya.tooltip,
					content: e.tooltip,
					children: e.type === "link" ? _(e.link, { children: n }) : n
				}, t);
			}
			case "divider": return /* @__PURE__ */ P(i.Divider, {}, t);
			default: return null;
		}
	};
	return /* @__PURE__ */ F(Ga, {
		open: o,
		onOpenChange: c,
		children: [/* @__PURE__ */ P(Ka, {
			asChild: !0,
			children: /* @__PURE__ */ P(l, {
				variant: "tertiary",
				icon: "dots-v",
				onClick: u,
				...n
			})
		}), /* @__PURE__ */ P(qa, { children: /* @__PURE__ */ P(Ja, {
			className: Ya.popover,
			side: r,
			align: a,
			sideOffset: 8,
			onOpenAutoFocus: (e) => e.preventDefault(),
			children: /* @__PURE__ */ P(i, { children: e.map((e, t) => d(e, t)) })
		}) })]
	});
}, Za = /* @__PURE__ */ Ke(((e, t) => {
	t.exports = { ...m };
})), Qa = /* @__PURE__ */ qe({ CountUp: () => eo }), $a, eo, to = Ge((() => {
	$a = function() {
		return ($a = Object.assign || function(e) {
			for (var t, n = 1, r = arguments.length; n < r; n++) for (var i in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, i) && (e[i] = t[i]);
			return e;
		}).apply(this, arguments);
	}, eo = function() {
		function e(e, t, n) {
			var r = this;
			this.endVal = t, this.options = n, this.version = "2.6.0", this.defaults = {
				startVal: 0,
				decimalPlaces: 0,
				duration: 2,
				useEasing: !0,
				useGrouping: !0,
				useIndianSeparators: !1,
				smartEasingThreshold: 999,
				smartEasingAmount: 333,
				separator: ",",
				decimal: ".",
				prefix: "",
				suffix: "",
				enableScrollSpy: !1,
				scrollSpyDelay: 200,
				scrollSpyOnce: !1
			}, this.finalEndVal = null, this.useEasing = !0, this.countDown = !1, this.error = "", this.startVal = 0, this.paused = !0, this.once = !1, this.count = function(e) {
				r.startTime ||= e;
				var t = e - r.startTime;
				r.remaining = r.duration - t, r.useEasing ? r.countDown ? r.frameVal = r.startVal - r.easingFn(t, 0, r.startVal - r.endVal, r.duration) : r.frameVal = r.easingFn(t, r.startVal, r.endVal - r.startVal, r.duration) : r.frameVal = r.startVal + (r.endVal - r.startVal) * (t / r.duration), r.frameVal = (r.countDown ? r.frameVal < r.endVal : r.frameVal > r.endVal) ? r.endVal : r.frameVal, r.frameVal = Number(r.frameVal.toFixed(r.options.decimalPlaces)), r.printValue(r.frameVal), t < r.duration ? r.rAF = requestAnimationFrame(r.count) : r.finalEndVal === null ? r.options.onCompleteCallback && r.options.onCompleteCallback() : r.update(r.finalEndVal);
			}, this.formatNumber = function(e) {
				var t, n, i, a, o = e < 0 ? "-" : "";
				t = Math.abs(e).toFixed(r.options.decimalPlaces);
				var s = (t += "").split(".");
				if (n = s[0], i = s.length > 1 ? r.options.decimal + s[1] : "", r.options.useGrouping) {
					a = "";
					for (var c = 3, l = 0, u = 0, d = n.length; u < d; ++u) r.options.useIndianSeparators && u === 4 && (c = 2, l = 1), u !== 0 && l % c == 0 && (a = r.options.separator + a), l++, a = n[d - u - 1] + a;
					n = a;
				}
				return r.options.numerals && r.options.numerals.length && (n = n.replace(/[0-9]/g, function(e) {
					return r.options.numerals[+e];
				}), i = i.replace(/[0-9]/g, function(e) {
					return r.options.numerals[+e];
				})), o + r.options.prefix + n + i + r.options.suffix;
			}, this.easeOutExpo = function(e, t, n, r) {
				return n * (1 - 2 ** (-10 * e / r)) * 1024 / 1023 + t;
			}, this.options = $a($a({}, this.defaults), n), this.formattingFn = this.options.formattingFn ? this.options.formattingFn : this.formatNumber, this.easingFn = this.options.easingFn ? this.options.easingFn : this.easeOutExpo, this.startVal = this.validateValue(this.options.startVal), this.frameVal = this.startVal, this.endVal = this.validateValue(t), this.options.decimalPlaces = Math.max(this.options.decimalPlaces), this.resetDuration(), this.options.separator = String(this.options.separator), this.useEasing = this.options.useEasing, this.options.separator === "" && (this.options.useGrouping = !1), this.el = typeof e == "string" ? document.getElementById(e) : e, this.el ? this.printValue(this.startVal) : this.error = "[CountUp] target is null or undefined", typeof window < "u" && this.options.enableScrollSpy && (this.error ? console.error(this.error, e) : (window.onScrollFns = window.onScrollFns || [], window.onScrollFns.push(function() {
				return r.handleScroll(r);
			}), window.onscroll = function() {
				window.onScrollFns.forEach(function(e) {
					return e();
				});
			}, this.handleScroll(this)));
		}
		return e.prototype.handleScroll = function(e) {
			if (e && window && !e.once) {
				var t = window.innerHeight + window.scrollY, n = e.el.getBoundingClientRect(), r = n.top + window.pageYOffset, i = n.top + n.height + window.pageYOffset;
				i < t && i > window.scrollY && e.paused ? (e.paused = !1, setTimeout(function() {
					return e.start();
				}, e.options.scrollSpyDelay), e.options.scrollSpyOnce && (e.once = !0)) : (window.scrollY > i || r > t) && !e.paused && e.reset();
			}
		}, e.prototype.determineDirectionAndSmartEasing = function() {
			var e = this.finalEndVal ? this.finalEndVal : this.endVal;
			this.countDown = this.startVal > e;
			var t = e - this.startVal;
			if (Math.abs(t) > this.options.smartEasingThreshold && this.options.useEasing) {
				this.finalEndVal = e;
				var n = this.countDown ? 1 : -1;
				this.endVal = e + n * this.options.smartEasingAmount, this.duration /= 2;
			} else this.endVal = e, this.finalEndVal = null;
			this.finalEndVal === null ? this.useEasing = this.options.useEasing : this.useEasing = !1;
		}, e.prototype.start = function(e) {
			this.error || (e && (this.options.onCompleteCallback = e), this.duration > 0 ? (this.determineDirectionAndSmartEasing(), this.paused = !1, this.rAF = requestAnimationFrame(this.count)) : this.printValue(this.endVal));
		}, e.prototype.pauseResume = function() {
			this.paused ? (this.startTime = null, this.duration = this.remaining, this.startVal = this.frameVal, this.determineDirectionAndSmartEasing(), this.rAF = requestAnimationFrame(this.count)) : cancelAnimationFrame(this.rAF), this.paused = !this.paused;
		}, e.prototype.reset = function() {
			cancelAnimationFrame(this.rAF), this.paused = !0, this.resetDuration(), this.startVal = this.validateValue(this.options.startVal), this.frameVal = this.startVal, this.printValue(this.startVal);
		}, e.prototype.update = function(e) {
			cancelAnimationFrame(this.rAF), this.startTime = null, this.endVal = this.validateValue(e), this.endVal !== this.frameVal && (this.startVal = this.frameVal, this.finalEndVal ?? this.resetDuration(), this.finalEndVal = null, this.determineDirectionAndSmartEasing(), this.rAF = requestAnimationFrame(this.count));
		}, e.prototype.printValue = function(e) {
			var t;
			if (this.el) {
				var n = this.formattingFn(e);
				(t = this.options.plugin) != null && t.render ? this.options.plugin.render(this.el, n) : this.el.tagName === "INPUT" ? this.el.value = n : this.el.tagName === "text" || this.el.tagName === "tspan" ? this.el.textContent = n : this.el.innerHTML = n;
			}
		}, e.prototype.ensureNumber = function(e) {
			return typeof e == "number" && !isNaN(e);
		}, e.prototype.validateValue = function(e) {
			var t = Number(e);
			return this.ensureNumber(t) ? t : (this.error = `[CountUp] invalid start or end value: ${e}`, null);
		}, e.prototype.resetDuration = function() {
			this.startTime = null, this.duration = 1e3 * Number(this.options.duration), this.remaining = this.duration;
		}, e;
	}();
})), no = /* @__PURE__ */ Ye((/* @__PURE__ */ Ke(((e) => {
	Object.defineProperty(e, "__esModule", { value: !0 });
	var t = Za(), n = (to(), Xe(Qa));
	function r(e, t) {
		var n = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
		if (n != null) {
			var r, i, a, o, s = [], c = !0, l = !1;
			try {
				if (a = (n = n.call(e)).next, t === 0) {
					if (Object(n) !== n) return;
					c = !1;
				} else for (; !(c = (r = a.call(n)).done) && (s.push(r.value), s.length !== t); c = !0);
			} catch (e) {
				l = !0, i = e;
			} finally {
				try {
					if (!c && n.return != null && (o = n.return(), Object(o) !== o)) return;
				} finally {
					if (l) throw i;
				}
			}
			return s;
		}
	}
	function i(e, t) {
		var n = Object.keys(e);
		if (Object.getOwnPropertySymbols) {
			var r = Object.getOwnPropertySymbols(e);
			t && (r = r.filter(function(t) {
				return Object.getOwnPropertyDescriptor(e, t).enumerable;
			})), n.push.apply(n, r);
		}
		return n;
	}
	function a(e) {
		for (var t = 1; t < arguments.length; t++) {
			var n = arguments[t] == null ? {} : arguments[t];
			t % 2 ? i(Object(n), !0).forEach(function(t) {
				o(e, t, n[t]);
			}) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : i(Object(n)).forEach(function(t) {
				Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
			});
		}
		return e;
	}
	function o(e, t, n) {
		return t = g(t), t in e ? Object.defineProperty(e, t, {
			value: n,
			enumerable: !0,
			configurable: !0,
			writable: !0
		}) : e[t] = n, e;
	}
	function s() {
		return s = Object.assign ? Object.assign.bind() : function(e) {
			for (var t = 1; t < arguments.length; t++) {
				var n = arguments[t];
				for (var r in n) Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
			}
			return e;
		}, s.apply(this, arguments);
	}
	function c(e, t) {
		if (e == null) return {};
		var n = {}, r = Object.keys(e), i, a;
		for (a = 0; a < r.length; a++) i = r[a], !(t.indexOf(i) >= 0) && (n[i] = e[i]);
		return n;
	}
	function l(e, t) {
		if (e == null) return {};
		var n = c(e, t), r, i;
		if (Object.getOwnPropertySymbols) {
			var a = Object.getOwnPropertySymbols(e);
			for (i = 0; i < a.length; i++) r = a[i], !(t.indexOf(r) >= 0) && Object.prototype.propertyIsEnumerable.call(e, r) && (n[r] = e[r]);
		}
		return n;
	}
	function u(e, t) {
		return d(e) || r(e, t) || f(e, t) || m();
	}
	function d(e) {
		if (Array.isArray(e)) return e;
	}
	function f(e, t) {
		if (e) {
			if (typeof e == "string") return p(e, t);
			var n = Object.prototype.toString.call(e).slice(8, -1);
			if (n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set") return Array.from(e);
			if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return p(e, t);
		}
	}
	function p(e, t) {
		(t == null || t > e.length) && (t = e.length);
		for (var n = 0, r = Array(t); n < t; n++) r[n] = e[n];
		return r;
	}
	function m() {
		throw TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
	}
	function h(e, t) {
		if (typeof e != "object" || !e) return e;
		var n = e[Symbol.toPrimitive];
		if (n !== void 0) {
			var r = n.call(e, t || "default");
			if (typeof r != "object") return r;
			throw TypeError("@@toPrimitive must return a primitive value.");
		}
		return (t === "string" ? String : Number)(e);
	}
	function g(e) {
		var t = h(e, "string");
		return typeof t == "symbol" ? t : String(t);
	}
	var _ = typeof window < "u" && window.document !== void 0 && window.document.createElement !== void 0 ? t.useLayoutEffect : t.useEffect;
	function v(e) {
		var n = t.useRef(e);
		return _(function() {
			n.current = e;
		}), t.useCallback(function() {
			var e = [...arguments];
			return n.current.apply(void 0, e);
		}, []);
	}
	var y = function(e, t) {
		var r = t.decimal, i = t.decimals, a = t.duration, o = t.easingFn, s = t.end, c = t.formattingFn, l = t.numerals, u = t.prefix, d = t.separator, f = t.start, p = t.suffix, m = t.useEasing, h = t.useGrouping, g = t.useIndianSeparators, _ = t.enableScrollSpy, v = t.scrollSpyDelay, y = t.scrollSpyOnce;
		return new n.CountUp(e, s, {
			startVal: f,
			duration: a,
			decimal: r,
			decimalPlaces: i,
			easingFn: o,
			formattingFn: c,
			numerals: l,
			separator: d,
			prefix: u,
			suffix: p,
			useEasing: m,
			useIndianSeparators: g,
			useGrouping: h,
			enableScrollSpy: _,
			scrollSpyDelay: v,
			scrollSpyOnce: y
		});
	}, b = [
		"ref",
		"startOnMount",
		"enableReinitialize",
		"delay",
		"onEnd",
		"onStart",
		"onPauseResume",
		"onReset",
		"onUpdate"
	], x = {
		decimal: ".",
		separator: ",",
		delay: null,
		prefix: "",
		suffix: "",
		duration: 2,
		start: 0,
		decimals: 0,
		startOnMount: !0,
		enableReinitialize: !0,
		useEasing: !0,
		useGrouping: !0,
		useIndianSeparators: !1
	}, S = function(e) {
		var n = Object.fromEntries(Object.entries(e).filter(function(e) {
			return u(e, 2)[1] !== void 0;
		})), r = t.useMemo(function() {
			return a(a({}, x), n);
		}, [e]), i = r.ref, o = r.startOnMount, s = r.enableReinitialize, c = r.delay, d = r.onEnd, f = r.onStart, p = r.onPauseResume, m = r.onReset, h = r.onUpdate, g = l(r, b), _ = t.useRef(), S = t.useRef(), C = t.useRef(!1), w = v(function() {
			return y(typeof i == "string" ? i : i.current, g);
		}), T = v(function(e) {
			var t = _.current;
			if (t && !e) return t;
			var n = w();
			return _.current = n, n;
		}), E = v(function() {
			var e = function() {
				return T(!0).start(function() {
					d?.({
						pauseResume: D,
						reset: O,
						start: A,
						update: k
					});
				});
			};
			c && c > 0 ? S.current = setTimeout(e, c * 1e3) : e(), f?.({
				pauseResume: D,
				reset: O,
				update: k
			});
		}), D = v(function() {
			T().pauseResume(), p?.({
				reset: O,
				start: A,
				update: k
			});
		}), O = v(function() {
			T().el && (S.current && clearTimeout(S.current), T().reset(), m?.({
				pauseResume: D,
				start: A,
				update: k
			}));
		}), k = v(function(e) {
			T().update(e), h?.({
				pauseResume: D,
				reset: O,
				start: A
			});
		}), A = v(function() {
			O(), E();
		}), j = v(function(e) {
			o && (e && O(), E());
		});
		return t.useEffect(function() {
			C.current ? s && j(!0) : (C.current = !0, j());
		}, [
			s,
			C,
			j,
			c,
			e.start,
			e.suffix,
			e.prefix,
			e.duration,
			e.separator,
			e.decimals,
			e.decimal,
			e.formattingFn
		]), t.useEffect(function() {
			return function() {
				O();
			};
		}, [O]), {
			start: A,
			pauseResume: D,
			reset: O,
			update: k,
			getCountUp: T
		};
	}, C = [
		"className",
		"redraw",
		"containerProps",
		"children",
		"style"
	];
	e.default = function(e) {
		var n = e.className, r = e.redraw, i = e.containerProps, o = e.children, c = e.style, u = l(e, C), d = t.useRef(null), f = t.useRef(!1), p = S(a(a({}, u), {}, {
			ref: d,
			startOnMount: typeof o != "function" || e.delay === 0,
			enableReinitialize: !1
		})), m = p.start, h = p.reset, g = p.update, _ = p.pauseResume, y = p.getCountUp, b = v(function() {
			m();
		}), x = v(function(t) {
			e.preserveValue || h(), g(t);
		}), w = v(function() {
			if (typeof e.children == "function" && !(d.current instanceof Element)) {
				console.error("Couldn't find attached element to hook the CountUp instance into! Try to attach \"containerRef\" from the render prop to a an Element, eg. <span ref={containerRef} />.");
				return;
			}
			y();
		});
		t.useEffect(function() {
			w();
		}, [w]), t.useEffect(function() {
			f.current && x(e.end);
		}, [e.end, x]);
		var T = r && e;
		return t.useEffect(function() {
			r && f.current && b();
		}, [
			b,
			r,
			T
		]), t.useEffect(function() {
			!r && f.current && b();
		}, [
			b,
			r,
			e.start,
			e.suffix,
			e.prefix,
			e.duration,
			e.separator,
			e.decimals,
			e.decimal,
			e.className,
			e.formattingFn
		]), t.useEffect(function() {
			f.current = !0;
		}, []), typeof o == "function" ? o({
			countUpRef: d,
			start: m,
			reset: h,
			update: g,
			pauseResume: _,
			getCountUp: y
		}) : /*#__PURE__*/ t.createElement("span", s({
			className: n,
			ref: d,
			style: c
		}, i), e.start === void 0 ? "" : y().formattingFn(e.start));
	}, e.useCountUp = S;
})))()), ro = {
	bar: "_bar_1n5dj_1",
	section: "_section_1n5dj_5",
	sectionHidden: "_sectionHidden_1n5dj_8",
	sectionInheritRadius: "_sectionInheritRadius_1n5dj_11",
	valueOutside: "_valueOutside_1n5dj_15"
}, io = ({ value: e, label: n, labelWidth: r, theme: i = ["var(--dixa-color-purple-700)", "var(--dixa-color-neutral-200)"], showFullBar: a = !1, showDifference: o = !1 }) => {
	let c = Math.min(e, 100), [l, u] = A([null, null]), d = ie(l);
	T(() => {
		u([c, ...a ? [100 - c] : []]);
	}, [c, a]);
	let p = 1.5, m = D(() => l.map((e, t) => {
		let n = c && t === 0 || o, r = e !== null && e < 20, l = I(ro.section, {
			[ro.sectionHidden]: a && e === 0,
			[ro.sectionInheritRadius]: !a
		}), u = I(ro.section, { [ro.valueOutside]: r });
		return /* @__PURE__ */ P(s, {
			justifyContent: "flex-end",
			alignItems: "center",
			padding: "0 100",
			background: i[t],
			color: "neutral.000",
			className: l,
			style: {
				flexBasis: `${e ?? 0}%`,
				transition: `flex-basis ${p}s ease-out`
			},
			children: n && /* @__PURE__ */ P(f.Paragraph, {
				className: u,
				variant: "4",
				color: t === 0 && !r ? "var(--dixa-color-neutral-000)" : "var(--dixa-color-neutral-900)",
				children: /* @__PURE__ */ P(no.default, {
					start: d?.[t] ?? 0,
					end: e ?? 0,
					duration: p,
					delay: 0,
					suffix: "%",
					children: ({ countUpRef: e }) => /* @__PURE__ */ P("span", { ref: e })
				})
			})
		}, t);
	}), [
		c,
		i,
		o,
		a,
		l,
		d
	]);
	return /* @__PURE__ */ F(s, {
		alignItems: "center",
		gap: "200",
		children: [n && /* @__PURE__ */ P(t, {
			minWidth: r ? `${r}px` : "auto",
			children: /* @__PURE__ */ P(f.Paragraph, {
				variant: "4",
				children: n
			})
		}), /* @__PURE__ */ P(s, {
			flex: "1",
			className: ro.bar,
			height: "20px",
			borderRadius: "50",
			children: m
		})]
	});
};
//#endregion
//#region src/utils/formatting/dateTime/dateTime.ts
function Z(e, t = { compact: !1 }) {
	if (e < 1e3) return `${(e / 1e3).toFixed(0)}s`;
	let n = Math.floor(e / 1e3 % 60), r = Math.floor(e / (1e3 * 60) % 60), i = Math.floor(e / (1e3 * 60 * 60) % 24), a = Math.floor(e / (1e3 * 60 * 60 * 24)), o = (e, t) => e > 0 ? `${e}${t}` : "";
	return [
		o(a, "d"),
		o(i, "h"),
		o(r, "m") || (t.compact ? "" : "0m"),
		o(n, "s") || (t.compact ? "" : "0s")
	].filter(Boolean).join(" ");
}
function ao(e) {
	return /^\d{4}-\d{2}-\d{2}(T\d{2}:\d{2}:\d{2}(\.\d{3})?(Z|[+-]\d{2}:\d{2})?)?$/.test(e) ? Te(e, Te.ISO_8601, !0).isValid() : !1;
}
//#endregion
//#region src/utils/formatting/number/number.ts
var oo = 1e6, so = 1e3;
function co(e) {
	if (e < so) return Q(e);
	let t = e >= oo, n = parseFloat((e / (t ? oo : so)).toFixed(1)), r = t ? "M" : "K";
	return `${Q(n)}${r}`;
}
function Q(e) {
	return e.toLocaleString(navigator.language);
}
//#endregion
//#region src/utils/instruments/categorizeInstruments/categorizeInstruments.ts
var lo = (e) => ({
	metrics: e.filter(uo),
	chart: e.find(fo),
	heatmap: e.find(po),
	table: e.find(mo),
	presence: e.find(ho),
	insight: e.find(go)
}), uo = (e) => e.type === "metric", fo = (e) => e.type === "chart" && e.visualization !== "heatmap", po = (e) => e.type === "chart" && e.visualization === "heatmap", mo = (e) => e.type === "table", ho = (e) => e.type === "presence", go = (e) => e.type === "ai_insight", _o = (e, t) => {
	switch (t) {
		case "duration": return Z(e).split(" ").slice(0, 2).join(" ");
		case "count": return co(e);
		case "number": return Q(e);
		case "percentage": return `${Q(e)}%`;
		case "timer": return Z(e);
		default: return "";
	}
}, vo = {
	default: 8,
	rating: 5
}, yo = Ee.purple[700], bo = (e) => /^#|^rgb(a)?\(|^hsl(a)?\(|^var\(/.test(e), xo = (e) => {
	let [t, n] = e.split("-"), r = Number(n);
	return vo[t] ? r >= 1 && r <= vo[t] : !1;
}, So = (e) => bo(e) ? e : xo(e) ? `var(--dixa-analytics-color-${e}, ${yo})` : yo, Co = (e, t = "default", n) => n ? So(n) : `var(--dixa-analytics-color-${t}-${e % (vo[t] ?? vo.default) + 1}, ${yo})`, wo = { container: "_container_1t2a7_1" }, $ = {
	tickCount: 5,
	tickProps: {
		fontFamily: "var(--dixa-typography-family-default)",
		fontSize: "var(--dixa-typography-size-200)",
		fill: "var(--dixa-typography-color-tertiary)"
	},
	visualizationIcons: {
		bar: "chart-bar",
		line: "chart-line",
		area: "chart-area",
		pie: "chart-pie",
		donut: "chart-donut"
	},
	instrumentFormatAssets: {
		count: {
			label: "#",
			description: "Absolute short numbers, e.g. 1.2K"
		},
		number: {
			label: "#",
			description: "Absolute numbers, e.g. 1.234"
		},
		percentage: {
			label: "%",
			description: "Relative percentages, e.g. 12.34%"
		},
		duration: {
			label: "s",
			description: "Durations, e.g. 12m 34s"
		}
	}
}, To = S(function({ formats: e, onChangeFormat: t }) {
	return /* @__PURE__ */ P(r, {
		variant: "secondary",
		children: e.map(({ value: e, selected: r }) => /* @__PURE__ */ P(n, {
			onClick: r ? void 0 : () => t?.(e),
			active: r,
			title: $.instrumentFormatAssets[e]?.description,
			children: $.instrumentFormatAssets[e]?.label
		}, e))
	});
}), Eo = S(function({ granularities: e, onChangeGranularity: t }) {
	return /* @__PURE__ */ P(r, {
		variant: "secondary",
		children: e.map(({ value: e, selected: r }) => /* @__PURE__ */ P(n, {
			onClick: r ? void 0 : () => t?.(e),
			active: r,
			children: e
		}, e))
	});
}), Do = {
	root: "_root_6kwn9_1",
	rootBounded: "_rootBounded_6kwn9_7",
	rootFluid: "_rootFluid_6kwn9_7"
}, Oo = ({ bounded: e = !1, fluid: t = !1, children: n }) => /* @__PURE__ */ P("div", {
	className: I(Do.root, {
		[Do.rootBounded]: e,
		[Do.rootFluid]: t
	}),
	children: n
}), ko = S(function({ data: e }) {
	let [t, n] = A(0);
	return T(() => {
		n(Math.max(0, Date.now() - e));
	}, [e]), te(() => {
		n(Math.max(0, Date.now() - e));
	}, 1e3), /* @__PURE__ */ P(N, { children: _o(t, "timer") });
}), Ao = {
	wrapper: "_wrapper_1w7q6_1",
	text: "_text_1w7q6_6"
}, jo = S(function({ className: e, data: t, format: n, color: r, suffix: i }) {
	let a = D(() => {
		if (t === null) return "n.a.";
		switch (n) {
			case "timer": return /* @__PURE__ */ P(ko, { data: t });
			default: return _o(t, n);
		}
	}, [t, n]), o = D(() => {
		if (t !== null) switch (n) {
			case "duration": return Z(t);
			case "count": return Q(t);
			default: return;
		}
	}, [t, n]);
	return /* @__PURE__ */ P(p, {
		content: o,
		disabled: !(t !== null && o !== a) || [
			"number",
			"percentage",
			"timer"
		].includes(n),
		wrap: "div",
		wrapProps: { className: Ao.wrapper },
		children: /* @__PURE__ */ F(f.Heading, {
			variant: "heading-1",
			color: r ?? (t === null ? "tertiary" : void 0),
			className: I(Ao.text, e),
			as: "span",
			children: [a, i]
		})
	});
}), Mo = { colorIndicator: "_colorIndicator_luubh_1" }, No = S(function({ instrument: e, theme: n = "light" }) {
	let { data: r, format: i, title: a, description: o, color: c } = e, l = c ? So(c) : void 0, u = n === "dark" ? "inherit" : void 0;
	return /* @__PURE__ */ F(s, {
		flexDirection: "column",
		gap: "100",
		children: [
			/* @__PURE__ */ F(s, {
				alignItems: "center",
				gap: "100",
				title: a,
				children: [c && /* @__PURE__ */ P(t, {
					as: "span",
					className: Mo.colorIndicator,
					background: l
				}), /* @__PURE__ */ P(f.Paragraph, {
					variant: "4",
					color: u,
					subdued: !0,
					children: a
				})]
			}),
			/* @__PURE__ */ P(jo, {
				data: r,
				format: i,
				color: u
			}),
			o && /* @__PURE__ */ P(f.Paragraph, {
				variant: "4",
				color: u,
				subdued: !0,
				children: o
			})
		]
	});
}), Po = ({ categories: e, series: t }, { omitZero: n }) => e.map((e, r) => {
	let i = t.reduce((e, { label: t, data: i }) => {
		let { value: a } = Fo(i[r]);
		return (n ? !a : a === null) ? e : {
			...e,
			[t]: a
		};
	}, {});
	return {
		name: e.label,
		...i
	};
}), Fo = (e) => e === null || typeof e == "number" ? { value: e } : {
	value: e?.value ?? null,
	metrics: e?.metrics
}, Io = (e) => e?.find(({ selected: e }) => e)?.value ?? "number", Lo = Oe, Ro = (e, t = "D", { long: n = !1, timezone: r = Te.tz.guess() } = {}) => {
	let i = Te.tz(e, r), a = Te.locale() === "en", o = (e) => n ? e.format("ddd, ll") : e.format(a ? "MMM DD" : "DD MMM");
	switch (t) {
		case "H": return i.format("LT");
		case "W": return n ? `${o(i)} - ${o(i.endOf("week"))} (W${i.format("W")})` : o(i);
		case "M": return i.format(n ? "MMM YYYY" : "MMM");
		default: return o(i);
	}
}, zo = (e, t = {}) => t?.length ? Lo(e, t) : e, Bo = { root: "_root_scczo_54" }, Vo = S(function({ instrument: e, granularity: t, timezone: n, tooltipProps: r }) {
	let { active: i, payload: a, label: o } = r, { categories: c, series: l } = e.data, u = c.find((e) => e.label === o), d = u?.metrics ?? [], p = Math.max(0, (a?.length ?? 0) - 24), m = Io(e.data.formats), h = D(() => l.length === 1 && ["count", "number"].includes(m) && !c.every(({ label: e }) => ao(e)) ? l[0].data.reduce((e, t) => {
		let { value: n } = Fo(t);
		return typeof n == "number" ? e + n : e;
	}, 0) : null, [
		c,
		m,
		l
	]), g = D(() => a?.slice(0, p > 0 ? 23 : 24).map((e) => {
		let t = e.value ?? 0, n = t && h ? t / h * 100 : null, r = n ? `${n.toFixed(2)}%` : void 0;
		return {
			type: "metric",
			title: e.name ?? "",
			color: e.color,
			data: t,
			format: m,
			description: r
		};
	}), [
		a,
		24,
		p,
		h,
		m
	]), _ = C((e) => e?.map((e) => /* @__PURE__ */ P(No, {
		instrument: e,
		theme: "dark"
	}, e.title)), []), v = D(() => u?.label ? ao(u.label) ? Ro(u.label, t, {
		timezone: n,
		long: !0
	}) : zo(u.label) : null, [
		u?.label,
		t,
		n
	]);
	return !i || !a ? null : /* @__PURE__ */ F("div", {
		className: Bo.root,
		children: [
			v && /* @__PURE__ */ F(s, {
				flexDirection: "column",
				gap: "100",
				children: [/* @__PURE__ */ P(f.Heading, {
					variant: "heading-2",
					color: "inherit",
					children: v
				}), u?.description && /* @__PURE__ */ P(f.Paragraph, {
					variant: "4",
					color: "inherit",
					children: u.description
				})]
			}),
			d.length > 0 && /* @__PURE__ */ P(Oo, {
				bounded: !0,
				children: _(d)
			}),
			/* @__PURE__ */ F(Oo, {
				bounded: !0,
				children: [_(g), p > 0 && /* @__PURE__ */ P(s, {
					flex: "1",
					alignItems: "center",
					children: /* @__PURE__ */ F(f.Heading, {
						variant: "heading-2",
						color: "inherit",
						children: [
							"+ ",
							p + 1,
							" more"
						]
					})
				})]
			})
		]
	});
}), Ho = ke, Uo = S(function({ visualization: e, visualizations: t, onChangeVisualization: n }) {
	return t.length <= 1 ? null : /* @__PURE__ */ P(r, {
		variant: "secondary",
		children: t.map((t) => /* @__PURE__ */ P(l, {
			icon: $.visualizationIcons[t],
			onClick: () => {
				n(t);
			},
			active: e === t,
			title: `${Ho(t)} chart`
		}, t))
	});
}), Wo = ({ instrument: e, granularity: t, timezone: n, syncOptions: r }) => {
	let { data: i, layout: a } = e, o = a === "horizontal", s = a === "vertical", c = D(() => {
		if (s) return 0;
		let e = i.categories.length % 2 == 0;
		switch (t) {
			case "H": return "preserveStart";
			case "D":
			case "W": return e ? "preserveEnd" : "preserveStart";
			default: return "preserveStartEnd";
		}
	}, [
		i.categories.length,
		t,
		s
	]), l = {
		dataKey: "name",
		width: s ? 192 : 0,
		tickLine: { stroke: "var(--dixa-color-neutral-200)" },
		axisLine: { stroke: "var(--dixa-color-neutral-200)" },
		tickSize: 6,
		tickMargin: 8,
		interval: c,
		tick: $.tickProps,
		tickFormatter: (e) => ao(e) ? Ro(e, t, { timezone: n }) : zo(e, { length: 192 / 10 })
	}, u = {
		domain: [0, "auto"],
		allowDecimals: !1,
		tickLine: !1,
		axisLine: !1,
		tick: $.tickProps,
		ticks: r?.ticks,
		tickCount: $.tickCount,
		tickFormatter: (e) => _o(e, Io(i.formats))
	};
	return {
		xAxisProps: o ? {
			type: "category",
			...l
		} : {
			type: "number",
			...u
		},
		yAxisProps: o ? {
			type: "number",
			...u
		} : {
			type: "category",
			...l
		}
	};
}, Go = Ae, Ko = {
	legendItem: "_legendItem_15b15_54",
	legendItemInactive: "_legendItemInactive_15b15_61",
	legendIcon: "_legendIcon_15b15_65",
	legendIconBar: "_legendIconBar_15b15_72",
	legendIconLine: "_legendIconLine_15b15_75"
}, qo = S(function({ instrument: e, legend: t, visualization: n, onToggleLegendItem: r, onMouseEnterLegendItem: i, onMouseLeaveLegendItem: a, hoveredLegend: o }) {
	let { series: c, options: l } = e.data, { layout: u } = l?.legend ?? { layout: "horizontal" }, d = u === "horizontal";
	return /* @__PURE__ */ P(s, {
		padding: d ? "0" : "0 0 0 400",
		flexDirection: d ? "row" : "column",
		gap: d ? "400" : "200",
		justifyContent: "center",
		children: c.map(({ label: e, options: c }, l) => {
			let u = Co(l, void 0, c?.color);
			return /* @__PURE__ */ F(s, {
				gap: "200",
				flexDirection: "row",
				alignItems: "center",
				className: I(Ko.legendItem, { [Ko.legendItemInactive]: o && o !== e }),
				onClick: () => r(e),
				onMouseEnter: () => i?.(e),
				onMouseLeave: () => a?.(e),
				children: [/* @__PURE__ */ P("span", {
					className: I(Ko.legendIcon, {
						[Ko.legendIconBar]: n !== "line",
						[Ko.legendIconLine]: n === "line"
					}),
					style: {
						borderColor: u,
						backgroundColor: t.includes(e) ? u : "transparent"
					}
				}), /* @__PURE__ */ P(f.Paragraph, {
					variant: "4",
					subdued: !0,
					children: e
				})]
			}, e);
		})
	});
}), Jo = ({ instrument: e, visualization: t }) => {
	let { data: { series: n, options: r } } = e, i = r?.legend?.layout === "horizontal", [a, o] = ne(n.filter(({ options: e }) => e?.visible ?? !0).map(({ label: e }) => e)), [s, c] = A(null);
	ae(() => {
		l();
	}, [n.length]);
	let l = C(() => {
		o.set(n.map(({ label: e }) => e));
	}, [n, o]), u = C((e) => {
		a.includes(e) && c(e);
	}, [a]), d = D(() => Go(u, 300), [u]), f = C(() => {
		d.cancel(), c(null);
	}, [d]), p = C((e) => {
		a.length === n.length ? o.filter((t) => t === e) : a.length === 1 && a.includes(e) ? l() : a.includes(e) ? o.removeAt(a.indexOf(e)) : o.push(e);
	}, [
		n.length,
		l,
		a,
		o
	]), m = D(() => n.length < 10 ? {
		onMouseEnterLegendItem: d,
		onMouseLeaveLegendItem: f,
		hoveredLegend: s
	} : {}, [
		d,
		f,
		s,
		n.length
	]);
	return {
		legend: a,
		legendProps: D(() => ({
			layout: r?.legend?.layout,
			align: i ? "center" : "right",
			verticalAlign: i ? "bottom" : "middle",
			wrapperStyle: {
				overflow: "auto",
				...i ? { bottom: 0 } : {
					right: 0,
					width: 208,
					maxHeight: "100%"
				}
			},
			content: () => /* @__PURE__ */ P(qo, {
				visualization: t,
				instrument: e,
				legend: a,
				onToggleLegendItem: p,
				...m
			})
		}), [
			p,
			e,
			i,
			a,
			m,
			r?.legend?.layout,
			t
		]),
		hoveredLegend: s
	};
}, Yo = je, Xo = Me, Zo = Ne, Qo = (e) => {
	let { outerRadius: t } = e;
	return /* @__PURE__ */ F("g", { children: [/* @__PURE__ */ P(xe, { ...e }), /* @__PURE__ */ P(xe, {
		...e,
		innerRadius: t,
		outerRadius: t + 10,
		fillOpacity: .4
	})] });
}, $o = (e) => {
	let { name: t, value: n, cx: r, cy: i, midAngle: a, outerRadius: o, fill: s, percent: c } = e;
	if (!n || !(typeof c == "number" && c >= .01) || !(typeof r == "number" && typeof i == "number" && typeof a == "number" && typeof o == "number")) return null;
	let l = Math.PI / 180, u = o + 24, d = r + o * Math.cos(-a * l), f = i + o * Math.sin(-a * l), p = r + u * Math.cos(-a * l), m = i + u * Math.sin(-a * l), h = p + (p > r ? 12 : -12), g = m;
	return /* @__PURE__ */ F(N, { children: [/* @__PURE__ */ P("polyline", {
		points: `${d},${f} ${p},${m} ${h},${g}`,
		stroke: s,
		fill: "none",
		strokeWidth: 1
	}), /* @__PURE__ */ P("text", {
		...$.tickProps,
		fill: De.color.secondary,
		x: h + (h > r ? 8 : -8),
		y: g,
		textAnchor: h > r ? "start" : "end",
		dominantBaseline: "middle",
		children: t
	})] });
}, es = ({ instrument: e, legend: t, hoveredLegend: n, hoveredCategory: r }) => {
	let { data: i, layout: a } = e, o = C(() => {
		let { categories: e, series: o } = i, s = o.filter(({ label: e }) => t.includes(e)), c = a === "vertical", l = c ? [
			0,
			2,
			2,
			0
		] : [
			2,
			2,
			0,
			0
		];
		return o.map(({ label: a, options: u, data: d }, f) => {
			let p = Co(f, i.options?.theme, u?.color), m = u?.stack, h = m ? s.filter((e) => e.options?.stack === m) : [], g = !m || Yo(h)?.label === a, _ = Io(i.formats), v = /* @__PURE__ */ F(N, { children: [s.length <= 10 && (!m || g) && /* @__PURE__ */ P(pe, {
				position: c ? "right" : "top",
				valueAccessor: ({ payload: e }) => m ? Zo(Object.values(Xo(e, h.map((e) => e.label)))) : Number(e[a] ?? 0),
				formatter: (e) => e ? _o(e, _) : "",
				...$.tickProps,
				offset: 8,
				fontSize: "var(--dixa-typography-size-100)",
				width: 0
			}), d.map((t, s) => /* @__PURE__ */ P(de, {
				fill: o.length > 1 ? p : Co(s, i.options?.theme, e[s]?.options?.color ?? u?.color),
				fillOpacity: (r === null || r === s) && (n === null || n === a) ? 1 : .4
			}, `${a}-${s}`))] });
			return {
				key: a,
				dataKey: a,
				stackId: m,
				fill: p,
				radius: g ? l : 0,
				maxBarSize: 80,
				hide: !t.includes(a),
				children: v
			};
		});
	}, [
		i,
		r,
		n,
		a,
		t
	]), s = C(() => {
		let { series: e } = i;
		return e.map(({ label: e, options: r }, a) => ({
			key: e,
			type: "monotone",
			dot: !1,
			activeDot: { r: 5 },
			dataKey: e,
			stroke: Co(a, i.options?.theme, r?.color),
			strokeWidth: 2,
			strokeOpacity: n === null || n === e ? 1 : .4,
			connectNulls: !0,
			hide: !t.includes(e)
		}));
	}, [
		i,
		n,
		t
	]), c = C(() => {
		let { series: e } = i;
		return e.map(({ label: e, options: r }, a) => {
			let o = Co(a, i.options?.theme, r?.color), s = n === null || n === e;
			return {
				key: e,
				type: "monotone",
				dot: !1,
				activeDot: { r: 5 },
				dataKey: e,
				stackId: r?.stack,
				stroke: o,
				strokeWidth: 2,
				fill: o,
				fillOpacity: s ? .9 : .2,
				strokeOpacity: +!!s,
				connectNulls: !0,
				hide: !t.includes(e)
			};
		});
	}, [
		i,
		n,
		t
	]), l = C((e) => {
		let { categories: t, series: n } = i, r = t.map(({ label: e, options: t }, n) => /* @__PURE__ */ P(de, {
			fill: Co(n, i.options?.theme, t?.color),
			style: { outline: "none" }
		}, e));
		return {
			dataKey: n[0]?.label,
			cx: "50%",
			cy: "50%",
			label: $o,
			labelLine: !1,
			activeShape: Qo,
			inactiveShape: { fillOpacity: .4 },
			stroke: Ee.neutral["000"],
			strokeWidth: 1.5,
			innerRadius: e === "donut" ? "50%" : 0,
			outerRadius: "80%",
			startAngle: 90,
			endAngle: -270,
			children: r
		};
	}, [i]);
	return { getSeriesProps: C((e) => {
		switch (e) {
			case "bar": return o();
			case "line": return s();
			case "area": return c();
			case "pie":
			case "donut": return l(e);
			default: return [];
		}
		return [];
	}, [
		c,
		o,
		s,
		l
	]) };
}, ts = S(function({ instrument: e, panel: t, timezone: n, syncOptions: r, onChangeGranularity: i, onChangeVisualization: a, onChangeFormat: c }) {
	let [l, u] = A(t.controls?.settings.visualization ?? e.visualization), [d, p] = A(null), { data: m, layout: h, title: _ } = e, v = h === "horizontal", y = h === "vertical", b = D(() => Po(m, { omitZero: l === "bar" }), [m, l]), x = D(() => m.granularities?.find(({ selected: e }) => e)?.value, [m.granularities]), S = D(() => {
		if (!m.options?.visualizations) return [];
		let e = ["bar"], t = m.series.length === 1;
		return m.categories.every(({ label: e }) => ao(e)) ? e.push("line", "area") : t && e.push("pie", "donut"), e;
	}, [
		m.categories,
		m.options?.visualizations,
		m.series.length
	]), { xAxisProps: w, yAxisProps: T } = Wo({
		instrument: e,
		granularity: x,
		timezone: n,
		syncOptions: r
	}), { legend: E, legendProps: O, hoveredLegend: k } = Jo({
		instrument: e,
		visualization: l
	}), { getSeriesProps: j } = es({
		instrument: e,
		legend: E,
		hoveredLegend: k,
		hoveredCategory: d
	});
	ae(() => {
		u(t.controls?.settings.visualization ?? e.visualization);
	}, [t.controls?.settings.visualization, e.visualization]);
	let M = C((e) => {
		u(e), a?.(e);
	}, [a]), ee = (e) => {
		if (!e?.isTooltipActive) {
			p(null);
			return;
		}
		let t = e.activeTooltipIndex;
		if (typeof t != "number") return;
		let n = Object.values(b[t] ?? {}).length > 1;
		p(n ? t : null);
	}, I = () => {
		p(null);
	}, te = () => l === "line" ? j(l).map(({ key: e, ...t }) => /* @__PURE__ */ P(he, { ...t }, e)) : l === "bar" ? j(l).map(({ key: e, ...t }) => /* @__PURE__ */ P(ce, { ...t }, e)) : l === "area" ? j(l).map(({ key: e, ...t }) => /* @__PURE__ */ P(oe, { ...t }, e)) : l === "pie" || l === "donut" ? /* @__PURE__ */ P(_e, {
		data: b,
		...j(l)
	}) : null, ne = () => {
		let i = m.options?.legend?.layout, a = {
			layout: h,
			syncId: r?.tooltip ? t.id : void 0,
			data: b,
			margin: {
				top: v ? 16 : 0,
				right: y || i === "vertical" ? 16 : 0,
				bottom: i === "horizontal" ? 16 / 2 : 0,
				left: 0
			}
		}, o = l === "bar" || l === "line" || l === "area", s = /* @__PURE__ */ F(N, { children: [
			o && /* @__PURE__ */ F(N, { children: [/* @__PURE__ */ P(Ce, { ...w }), /* @__PURE__ */ P(we, { ...T })] }),
			o && m.options?.cartesian && /* @__PURE__ */ P(ue, {
				vertical: y,
				horizontal: v,
				stroke: "var(--dixa-color-neutral-200)"
			}),
			o && m.references?.map(({ value: e, label: t }, n) => /* @__PURE__ */ P(ye, {
				...v ? { y: e } : { x: e },
				stroke: "var(--dixa-color-neutral-500)",
				strokeDasharray: "5 5",
				isFront: !0,
				children: /* @__PURE__ */ P(fe, {
					value: t,
					offset: 8,
					fontSize: "var(--dixa-typography-size-200)",
					position: v ? "insideBottomLeft" : "insideTopLeft"
				})
			}, n)),
			m.options?.legend && /* @__PURE__ */ P(me, { ...O }),
			m.options?.tooltip && /* @__PURE__ */ P(Se, {
				content: (t) => /* @__PURE__ */ P(Vo, {
					instrument: e,
					granularity: x,
					timezone: n,
					tooltipProps: t
				}),
				cursor: { fill: "transparent" }
			}),
			te()
		] });
		switch (l) {
			case "bar": return /* @__PURE__ */ P(le, {
				...a,
				barGap: "1",
				onMouseMove: ee,
				onMouseLeave: I,
				children: s
			});
			case "line": return /* @__PURE__ */ P(ge, {
				...a,
				children: s
			});
			case "area": return /* @__PURE__ */ P(se, {
				...a,
				children: s
			});
			case "pie":
			case "donut": return /* @__PURE__ */ P(ve, {
				...a,
				children: s
			});
		}
	};
	if (!m.categories.length || !m.series.length) return /* @__PURE__ */ P(s, {
		flexDirection: "column",
		alignItems: "center",
		justifyContent: "center",
		height: "100%",
		children: /* @__PURE__ */ P(o, {
			title: "No data available",
			description: "There is no data available for the selected period and filters.",
			icon: $.visualizationIcons[l]
		})
	});
	let re = [
		m.formats && m.formats.length > 1 ? /* @__PURE__ */ P(To, {
			formats: m.formats,
			onChangeFormat: c
		}, "format") : null,
		m.granularities && m.granularities.length > 1 ? /* @__PURE__ */ P(Eo, {
			granularities: m.granularities,
			onChangeGranularity: i
		}, "granularity") : null,
		m.options?.visualizations ? /* @__PURE__ */ P(Uo, {
			visualization: l,
			visualizations: S,
			onChangeVisualization: M
		}, "visualization") : null
	], ie = re.some(Boolean);
	return /* @__PURE__ */ F(N, { children: [
		_ && /* @__PURE__ */ P("div", { children: /* @__PURE__ */ P(f.Heading, {
			variant: "heading-4",
			children: _
		}) }),
		ie && /* @__PURE__ */ P(s, {
			alignSelf: "flex-end",
			gap: "300",
			children: re.map((e, t) => /* @__PURE__ */ P(g, { children: e }, t))
		}),
		/* @__PURE__ */ P(be, {
			className: wo.container,
			width: "100%",
			height: "100%",
			debounce: 100,
			children: ne()
		})
	] });
}), ns = Pe, rs = Fe, is = { trigger: "_trigger_1mrk9_1" }, as = S(function({ title: e, metrics: t, children: n }) {
	return /* @__PURE__ */ P(p, {
		content: /* @__PURE__ */ F(s, {
			flexDirection: "column",
			gap: "200",
			children: [/* @__PURE__ */ P(f.Paragraph, {
				variant: "1",
				color: "inherit",
				children: e
			}), t.length > 0 && /* @__PURE__ */ P(Oo, {
				bounded: !0,
				children: t.map((e, t) => /* @__PURE__ */ P(No, {
					instrument: e,
					theme: "dark"
				}, t))
			})]
		}),
		wrap: "div",
		wrapProps: { className: is.trigger },
		children: n
	});
}), os = {
	cell: "_cell_hfkay_1",
	cellText: "_cellText_hfkay_11",
	cellDimmed: "_cellDimmed_hfkay_14",
	cellContent: "_cellContent_hfkay_18"
}, ss = S(function({ cell: e, dimmed: t = !1, background: n = "transparent", tooltipProps: r, textProps: i = {}, onMouseEnter: a }) {
	let [o, s] = A(!1), c = ie(e?.value);
	ae(() => {
		if (e?.value !== c) {
			s(!0);
			let e = setTimeout(() => {
				s(!1);
			}, 200);
			return () => {
				clearTimeout(e);
			};
		}
	}, [e?.value]);
	let l = D(() => {
		if (!e) return null;
		let { value: t, format: n } = e;
		return typeof t == "string" ? t : typeof t == "number" && n ? _o(t, n) : "—";
	}, [e]);
	if (!e) return /* @__PURE__ */ P("div", {
		className: os.cell,
		onMouseEnter: a,
		"data-testid": "heatmap-instrument-cell"
	});
	let u = /* @__PURE__ */ P("div", {
		className: os.cellContent,
		children: /* @__PURE__ */ P(f.Paragraph, {
			className: I({ [os.cellText]: typeof e.value == "string" }),
			variant: "3",
			subdued: !rs(e.value),
			...i,
			children: l
		})
	});
	return /* @__PURE__ */ P("div", {
		className: I(os.cell, { [os.cellDimmed]: t || o }),
		onMouseEnter: a,
		style: { backgroundColor: n },
		"data-animating": o,
		"data-testid": "heatmap-instrument-cell",
		children: r?.enabled ? /* @__PURE__ */ P(as, {
			...r,
			children: u
		}) : u
	});
}), cs = {
	grid: "_grid_1qk2p_1",
	row: "_row_1qk2p_7"
}, ls = Number.isNaN || function(e) {
	return typeof e == "number" && e !== e;
};
function us(e, t) {
	return !!(e === t || ls(e) && ls(t));
}
function ds(e, t) {
	if (e.length !== t.length) return !1;
	for (var n = 0; n < e.length; n++) if (!us(e[n], t[n])) return !1;
	return !0;
}
function fs(e, t) {
	t === void 0 && (t = ds);
	var n = null;
	function r() {
		var r = [...arguments];
		if (n && n.lastThis === this && t(r, n.lastArgs)) return n.lastResult;
		var i = e.apply(this, r);
		return n = {
			lastResult: i,
			lastArgs: r,
			lastThis: this
		}, i;
	}
	return r.clear = function() {
		n = null;
	}, r;
}
//#endregion
//#region src/components/instruments/heatmapInstrument/utils/heatmapTheming.ts
var ps = [
	"100",
	"200",
	"400",
	"500",
	"700"
].map((e) => `var(--dixa-color-purple-${e})`), ms = fs((e) => {
	if (e === null) return {
		backgroundColor: "var(--dixa-color-neutral-000)",
		color: "tertiary"
	};
	let t = Math.min(4, Math.floor(5 / 100 * Math.min(e, 100)));
	return {
		backgroundColor: ps?.[t] ?? "var(--dixa-color-neutral-000)",
		color: t >= 3 ? "white" : "primary"
	};
});
function hs(e) {
	return typeof e == "number" && !Number.isNaN(e) && e >= 0;
}
var gs = (e) => {
	let t = e.flatMap(({ data: e }) => e.map((e) => Fo(e).value)).filter(hs);
	return {
		min: Math.min(...t),
		max: Math.max(...t)
	};
}, _s = (e, { min: t, max: n }) => t === n ? 100 : Math.round(100 * (e - t) / (n - t)), vs = ({ instrument: e }) => {
	let { data: { categories: t, series: n } } = e, r = k(null), [i, a] = re({
		cell: null,
		column: null,
		row: null
	}), o = D(() => Object.values(i).some((e) => e !== null), [i]), s = D(() => gs(n), [n]);
	E(() => {
		let e = (e) => {
			r.current && !r.current.contains(e.target) && o && a.reset();
		};
		return window.addEventListener("mousemove", e, !0), () => {
			window.removeEventListener("mousemove", e, !0);
		};
	}, [o, a]);
	let c = C((e) => {
		if (!o) return !1;
		let [t, n] = e;
		return i.cell ? !ns(i.cell.id, e) : i.column === null ? i.row !== null && i.row !== t : i.column !== n;
	}, [
		o,
		i.cell,
		i.column,
		i.row
	]), l = C((e) => a.setAll({
		cell: null,
		column: e,
		row: null
	}), [a]), u = C((e) => a.setAll({
		cell: null,
		column: null,
		row: e
	}), [a]), d = C((e) => {
		(o || e !== null) && a.setAll({
			cell: e,
			column: null,
			row: null
		});
	}, [o, a]), f = C(() => {
		o && a.reset();
	}, [o, a]);
	return /* @__PURE__ */ F("div", {
		ref: r,
		className: cs.grid,
		onMouseLeave: () => a.reset(),
		"data-testid": "heatmap-instrument",
		children: [/* @__PURE__ */ F("div", {
			className: cs.row,
			children: [/* @__PURE__ */ P(ss, { onMouseEnter: f }), n.map((e, t) => {
				let r = n[t].metrics ?? [];
				return /* @__PURE__ */ P(ss, {
					cell: {
						id: [0, t],
						value: e.label
					},
					tooltipProps: {
						enabled: r.length > 0,
						title: e.label,
						metrics: r
					},
					onMouseEnter: () => l(t)
				}, e.label);
			})]
		}), t.map((r, i) => {
			let a = t[i].metrics ?? [];
			return /* @__PURE__ */ F("div", {
				className: cs.row,
				children: [/* @__PURE__ */ P(ss, {
					cell: {
						id: [i, 0],
						value: r.label
					},
					tooltipProps: {
						enabled: a.length > 0,
						title: r.label,
						metrics: a
					},
					onMouseEnter: () => u(i)
				}), n.map((t, n) => {
					let a = [i, n], { value: o, metrics: l } = Fo(t.data[i]), u = Io(e.data.formats), f = rs(o), { backgroundColor: p, color: m } = ms(f ? _s(o, s) : null);
					return /* @__PURE__ */ P(ss, {
						cell: {
							id: a,
							value: o,
							format: u
						},
						dimmed: c(a),
						background: p,
						tooltipProps: {
							enabled: f,
							title: `${r.label}, ${t.label}`,
							metrics: l?.length ? l : [{
								type: "metric",
								title: "Total",
								data: o,
								format: u === "count" ? "number" : u
							}]
						},
						textProps: { color: m },
						onMouseEnter: () => d(f ? {
							id: a,
							value: o
						} : null)
					}, a.join(","));
				})]
			}, r.label);
		})]
	});
}, ys = {
	legend: "_legend_1k9xu_54",
	trigger: "_trigger_1k9xu_58",
	popover: "_popover_1k9xu_64",
	breakdown: "_breakdown_1k9xu_83"
}, bs = S(function({ instrument: e }) {
	let { data: { availability: n, media_type: r, away: i } } = e, o = ["var(--dixa-color-purple-700)", "var(--dixa-color-neutral-200)"], c = "No data available", u = {
		labelWidth: Math.max(...r.map((e) => e.label.length)) * 7,
		theme: o
	}, d = () => /* @__PURE__ */ P(io, {
		...u,
		value: 0,
		label: "n.a.",
		theme: ["var(--dixa-color-neutral-200)", "var(--dixa-color-neutral-200)"],
		showFullBar: !0
	});
	return /* @__PURE__ */ F(s, {
		flexDirection: "column",
		gap: "400",
		children: [/* @__PURE__ */ F(s, {
			flexDirection: "column",
			gap: "300",
			children: [/* @__PURE__ */ P(f.Paragraph, {
				variant: "4",
				subdued: !0,
				children: n.length ? "Availability" : c
			}), n.length ? /* @__PURE__ */ F(N, { children: [/* @__PURE__ */ F(s, {
				gap: "300",
				className: ys.legend,
				children: [n.map((e, n) => /* @__PURE__ */ F(s, {
					gap: "200",
					alignItems: "center",
					children: [/* @__PURE__ */ P(t, {
						width: "6px",
						height: "6px",
						background: o[n],
						borderRadius: "50%"
					}), /* @__PURE__ */ P(f.Paragraph, {
						variant: "4",
						children: e.label
					})]
				}, n)), (() => {
					if (!i || !i.length) return null;
					let [e, t, ...n] = i;
					return /* @__PURE__ */ F(Ga, { children: [/* @__PURE__ */ P(Ka, {
						asChild: !0,
						children: /* @__PURE__ */ P(l, {
							variant: "tertiary",
							icon: "dots-h",
							className: ys.trigger
						})
					}), /* @__PURE__ */ P(qa, { children: /* @__PURE__ */ P(Ja, {
						side: "right",
						className: ys.popover,
						children: /* @__PURE__ */ F("ul", {
							className: ys.breakdown,
							children: [
								/* @__PURE__ */ F("li", { children: [/* @__PURE__ */ P(f.Paragraph, {
									variant: "1",
									children: e.label
								}), /* @__PURE__ */ P(f.Paragraph, {
									variant: "1",
									children: Z(e.value)
								})] }),
								/* @__PURE__ */ F("li", { children: [/* @__PURE__ */ P(f.Paragraph, {
									variant: "2",
									subdued: !0,
									children: t.label
								}), /* @__PURE__ */ P(f.Paragraph, {
									variant: "2",
									subdued: !0,
									children: Z(t.value)
								})] }),
								/* @__PURE__ */ P(a, {}),
								n.map((e, t) => /* @__PURE__ */ F("li", { children: [/* @__PURE__ */ P(f.Paragraph, {
									variant: "2",
									children: e.label
								}), /* @__PURE__ */ P(f.Paragraph, {
									variant: "1",
									children: Z(e.value)
								})] }, t))
							]
						})
					}) })] });
				})()]
			}), /* @__PURE__ */ P(io, {
				...u,
				value: n[0].value,
				label: "Total",
				showFullBar: !0,
				showDifference: !0
			})] }) : d()]
		}), /* @__PURE__ */ F(s, {
			flexDirection: "column",
			gap: "300",
			children: [/* @__PURE__ */ P(f.Paragraph, {
				variant: "4",
				subdued: !0,
				children: r.length ? "Availability per channel" : c
			}), r.length > 0 ? /* @__PURE__ */ P(s, {
				flexDirection: "column",
				gap: "200",
				children: r.map((e, t) => /* @__PURE__ */ y(io, {
					...u,
					key: t,
					value: e.value,
					label: e.label
				}))
			}) : d()]
		})]
	});
}), xs = {
	tooltip: "_tooltip_h4i5v_1",
	trigger: "_trigger_h4i5v_5"
}, Ss = ({ text: e }) => /* @__PURE__ */ F(N, { children: [/* @__PURE__ */ P("span", { children: e }), /* @__PURE__ */ P(p, {
	className: xs.tooltip,
	content: e,
	wrap: "div",
	wrapProps: { className: xs.trigger }
})] }), Cs = S(function({ value: e }) {
	let [t, ...n] = e;
	return /* @__PURE__ */ F(s, {
		gap: "200",
		alignItems: "center",
		children: [/* @__PURE__ */ P(f.Paragraph, {
			variant: "2",
			as: "span",
			children: t
		}), n.length > 0 && /* @__PURE__ */ P(p, {
			content: n.join(", "),
			children: /* @__PURE__ */ F(f.ExternalLink, {
				as: "span",
				children: [
					"+ ",
					n.length,
					" more"
				]
			})
		})]
	});
}), ws = ({ cell: t, format: n, timezone: r, customFormats: i }) => {
	let a = D(() => {
		if (!t || Ts(t.value)) return /* @__PURE__ */ P(f.Paragraph, {
			variant: "2",
			color: "neutral.500",
			children: "n.a."
		});
		let { value: e, label: a } = t;
		if (a) return a;
		if (i?.[n]) return i[n]?.({ value: e });
		switch (n) {
			case "boolean": return e ? "Y" : "N";
			case "date": return Te.tz(e, r).format("L, LT");
			case "count": return co(e);
			case "number": return Q(e);
			case "percentage": return `${Q(e)}%`;
			case "duration": return Z(e);
			case "csid": return `#${e}`;
			case "rating": return `${e}`;
			case "presence": return /* @__PURE__ */ P(io, {
				value: e,
				showFullBar: !0
			});
			case "tags": return /* @__PURE__ */ P(Ie, {
				tags: e,
				limit: 1
			});
			case "text": return /* @__PURE__ */ P(Ss, { text: e });
			case "list": return /* @__PURE__ */ P(Cs, { value: e });
			default: return `${e}`;
		}
	}, [
		t,
		i,
		n,
		r
	]);
	return t?.ui?.type === "badge" ? /* @__PURE__ */ P(e, {
		variant: t.ui.variant,
		size: "medium",
		children: /* @__PURE__ */ P(N, { children: a })
	}) : /* @__PURE__ */ P(N, { children: a });
};
function Ts(e) {
	let t = e === null, n = typeof e == "string" && e.trim() === "", r = Array.isArray(e) && !e.length;
	return t || n || r;
}
var Es = {
	tableWrapper: "_tableWrapper_1xmkm_1",
	tableWrapperEmpty: "_tableWrapperEmpty_1xmkm_4",
	thCell: "_thCell_1xmkm_8",
	tdCell: "_tdCell_1xmkm_12",
	tooltip: "_tooltip_1xmkm_20"
}, Ds = Le, Os = Re, ks = (e) => typeof e == "string" || typeof e == "number" || typeof e == "boolean", As = (e, t) => {
	let n = e.cells.find((e) => e.column === t.key);
	return !n || n.value === null ? null : (n.value, n.value);
}, js = ({ data: { columns: e, rows: t }, limit: n = 50, sortStatus: r }) => {
	let i = Math.ceil(t.length / n), [a, o] = A(1);
	ae(() => {
		a !== 1 && o(1);
	}, [r, i]);
	let s = D(() => {
		if (!r) return t;
		let n = e.find(({ key: e }) => e === r.sortBy);
		return n ? Os(t, [(e) => !Ds(As(e, n)), (e) => As(e, n)], ["desc", r.direction]) : t;
	}, [
		e,
		t,
		r
	]);
	return {
		rows: D(() => s.slice((a - 1) * n, a * n), [
			a,
			n,
			s
		]),
		currentPage: a,
		totalPages: i,
		setPage: o
	};
}, Ms = ({ instrument: e, timezone: t, onReadInstruments: r, onLoadAll: i, onSortChange: a, customFormats: l }) => {
	let { title: p, data: m, data: { columns: h, options: g } } = e, [_, v] = A(null), y = k(null), b = g?.limit ?? 50, { rows: x, currentPage: S, totalPages: w, setPage: T } = js({
		data: m,
		limit: b,
		sortStatus: _
	}), E = m.rows.length === 0, D = !!g?.next_page, O = !D && w > 1;
	ae(() => {
		y.current && (y.current.scrollTop = 0);
	}, [S]);
	let j = C(() => (i?.(), r({ meta: { pagination: { limit: null } } })), [i, r]), M = C(async (e) => {
		D && await j(), v(e), a?.(e);
	}, [
		j,
		a,
		D
	]);
	return /* @__PURE__ */ F(N, { children: [p && /* @__PURE__ */ P("div", { children: /* @__PURE__ */ P(f.Heading, {
		variant: "heading-4",
		children: p
	}) }), /* @__PURE__ */ F(d, {
		stickyHeader: !0,
		sortingProps: {
			sortStatus: _,
			onSortChange: M
		},
		wrapperProps: { className: I(Es.tableWrapper, { [Es.tableWrapperEmpty]: E }) },
		wrapperRef: y,
		hoverable: !E,
		children: [
			/* @__PURE__ */ P(d.Thead, { children: /* @__PURE__ */ P(d.Tr, { children: h.map(({ key: e, label: t, sortable: n }) => /* @__PURE__ */ P(d.Th, {
				className: Es.thCell,
				columnId: n ? e : null,
				children: t
			}, e)) }) }),
			/* @__PURE__ */ F(d.Tbody, { children: [E && /* @__PURE__ */ P(d.Tr, { children: /* @__PURE__ */ P(d.Td, {
				colSpan: h.length,
				children: /* @__PURE__ */ P(o, {
					title: "No data available",
					description: "There is no data available for the selected period and filters.",
					icon: "th"
				})
			}) }), x.map((e, n) => {
				let r = `row-${n}`;
				return /* @__PURE__ */ P(d.Tr, { children: h.map(({ key: n, format: i }, a) => {
					let o = e.cells.find((e) => e.column === n);
					return /* @__PURE__ */ P(d.Td, {
						className: Es.tdCell,
						children: /* @__PURE__ */ P(ws, {
							cell: o,
							format: i,
							timezone: t,
							customFormats: l
						})
					}, `${r}-cell-${a}`);
				}) }, r);
			})] }),
			D && /* @__PURE__ */ P(d.Footer, { children: /* @__PURE__ */ F(s, {
				alignItems: "center",
				justifyContent: "center",
				gap: "300",
				children: [/* @__PURE__ */ F(s, {
					gap: "100",
					alignItems: "center",
					children: [/* @__PURE__ */ P(c, {
						tooltipClassName: Es.tooltip,
						text: `By default we only load the first ${b} results. If you need to see all available results, click on the button, but beware that this may take a bit of time to load depending on the number of results.`
					}), /* @__PURE__ */ F(f.Paragraph, {
						variant: "2",
						children: ["Showing only the ", /* @__PURE__ */ F("b", { children: [
							"first ",
							b,
							" results"
						] })]
					})]
				}), /* @__PURE__ */ P(n, {
					variant: "secondary",
					onClick: j,
					children: "Load all results"
				})]
			}) }),
			O && /* @__PURE__ */ P(d.Footer, { children: /* @__PURE__ */ P(s, {
				alignItems: "center",
				justifyContent: "center",
				children: /* @__PURE__ */ P(u, {
					pageCount: w,
					currentPage: S,
					pageRangeDisplayed: 6,
					onPageChange: T
				})
			}) })
		]
	})] });
};
//#endregion
export { Xa as AnalyticsMenu, ts as ChartInstrument, vs as HeatmapInstrument, No as MetricInstrument, jo as MetricInstrumentData, Oo as MetricInstrumentsGrid, io as PercentageBar, bs as PresenceInstrument, Ms as TableInstrument, lo as categorizeInstruments, $ as chartAppearance, co as formatAbbreviateNumber, _o as formatInstrumentNumber, Q as formatLocalizedNumber, Z as formatMillisecondsToDuration, Io as getChartSeriesFormat, Fo as getChartSeriesValue, go as isAIInsightInstrument, fo as isChartInstrument, ao as isDateLikeString, po as isHeatmapInstrument, uo as isMetricInstrument, ho as isPresenceInstrument, mo as isTableInstrument, ks as isTableInstrumentDataValuePrimitive, Co as resolveChartElementColor, So as resolveInstrumentColor };

//# sourceMappingURL=index.js.map